/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-home","1":"route-about","2":"route-courses"}[chunkId]||chunkId) + ".chunk." + {"0":"8907f","1":"a417a","2":"c938e"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+eY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__jQNF7"};

/***/ }),

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "2S6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobileHeaderContainer":"mobileHeaderContainer__1ku_H","mobileHeaderContainerToggled":"mobileHeaderContainerToggled__PeTb6","contentContainer":"contentContainer__3N4c1","mobileMenu":"mobileMenu__2tVjS","hamburger":"hamburger__1siVU","hamburgerContainer":"hamburgerContainer__160Eo","contentContainerToggled":"contentContainerToggled__1bZQq","mobileMenuToggled":"mobileMenuToggled__1GdbF","hamburgerContainerToggled":"hamburgerContainerToggled__1c-tv","hamburgerToggled":"hamburgerToggled__29S0D"};

/***/ }),

/***/ "4CJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"text":"text__1L6Fq","xs":"xs__34uFW","sm":"sm__2gVLL","md":"md__2BZVW","lg":"lg__39HQX"};

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "ASFD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0a775cbf20c57d57fbd3c72f59b9c08d.svg";

/***/ }),

/***/ "BVH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("ohqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);




var flexAlignToClass = {
  'initial': 'align-initial',
  'start': 'align-start',
  'end': 'align-end',
  'center': 'align-center',
  'stretch': 'align-stretch'
};
var justifyContentToClass = {
  'initial': 'justify-initial',
  'start': 'justify-start',
  'end': 'justify-end',
  'center': 'justify-center',
  'around': 'justify-around',
  'between': 'justify-between'
};
var directionToSmClass = {
  'row': 'smRow',
  'column': 'smColumn'
};

var Box = function Box(_ref) {
  var children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === undefined ? 'row' : _ref$direction,
      _ref$smDirection = _ref.smDirection,
      smDirection = _ref$smDirection === undefined ? '' : _ref$smDirection,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'transparent' : _ref$color,
      _ref$border = _ref.border,
      border = _ref$border === undefined ? 'square' : _ref$border,
      _ref$align = _ref.align,
      align = _ref$align === undefined ? 'initial' : _ref$align,
      _ref$justify = _ref.justify,
      justify = _ref$justify === undefined ? 'initial' : _ref$justify,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === undefined ? '' : _ref$maxWidth,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? '' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? '' : _ref$height,
      _ref$paddingY = _ref.paddingY,
      paddingY = _ref$paddingY === undefined ? '' : _ref$paddingY,
      _ref$paddingX = _ref.paddingX,
      paddingX = _ref$paddingX === undefined ? '' : _ref$paddingX,
      _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === undefined ? '' : _ref$marginTop,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === undefined ? '' : _ref$marginBottom,
      _ref$marginLeft = _ref.marginLeft,
      marginLeft = _ref$marginLeft === undefined ? '' : _ref$marginLeft,
      _ref$marginRight = _ref.marginRight,
      marginRight = _ref$marginRight === undefined ? '' : _ref$marginRight,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === undefined ? 'nowrap' : _ref$wrap,
      _ref$overflow = _ref.overflow,
      overflow = _ref$overflow === undefined ? 'visible' : _ref$overflow,
      className = _ref.className;

  var classes = [__WEBPACK_IMPORTED_MODULE_1__style___default.a.box, __WEBPACK_IMPORTED_MODULE_1__style___default.a[direction], __WEBPACK_IMPORTED_MODULE_1__style___default.a[directionToSmClass[smDirection]], __WEBPACK_IMPORTED_MODULE_1__style___default.a[color], __WEBPACK_IMPORTED_MODULE_1__style___default.a[border], __WEBPACK_IMPORTED_MODULE_1__style___default.a[flexAlignToClass[align]], __WEBPACK_IMPORTED_MODULE_1__style___default.a[justifyContentToClass[justify]], __WEBPACK_IMPORTED_MODULE_1__style___default.a[wrap], className];

  var styles = {
    maxWidth: maxWidth,
    width: width,
    paddingTop: paddingY,
    paddingBottom: paddingY,
    paddingLeft: paddingX,
    paddingRight: paddingX,
    marginTop: marginTop,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginBottom: marginBottom,
    height: height,
    overflow: overflow
  };
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': classes.join(' '), style: styles },
    children
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Box);

/***/ }),

/***/ "Ind5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f65f35c23926605972710dd521715f19.svg";

/***/ }),

/***/ "JT19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("szLA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("4CJ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);





var Text = function Text(_ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'gray' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'md' : _ref$size,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === undefined ? 'normal' : _ref$fontWeight,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === undefined ? 'left' : _ref$textAlign,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === undefined ? 2 : _ref$lineHeight,
      _ref$columnCount = _ref.columnCount,
      columnCount = _ref$columnCount === undefined ? 1 : _ref$columnCount,
      _ref$columnGap = _ref.columnGap,
      columnGap = _ref$columnGap === undefined ? 0 : _ref$columnGap;

  var classes = [__WEBPACK_IMPORTED_MODULE_2__style___default.a.text, __WEBPACK_IMPORTED_MODULE_2__style___default.a[size], __WEBPACK_IMPORTED_MODULE_1__style___default.a[color], __WEBPACK_IMPORTED_MODULE_1__style___default.a[fontWeight], __WEBPACK_IMPORTED_MODULE_1__style___default.a[textAlign]];
  var inlineStyle = {
    lineHeight: lineHeight,
    columnCount: columnCount,
    columnGap: columnGap
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    { 'class': classes.join(' '), style: inlineStyle },
    children
  );
};
/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.css
var style = __webpack_require__("rq4c");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/mixpanel-browser/build/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__("bMV/");
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/header/style.css
var header_style = __webpack_require__("u3et");
var header_style_default = /*#__PURE__*/__webpack_require__.n(header_style);

// CONCATENATED MODULE: ./components/header/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var header_Header = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, Header);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Header.prototype.render = function render() {
		return Object(preact_min["h"])(
			'header',
			{ 'class': header_style_default.a.header },
			Object(preact_min["h"])(
				'nav',
				null,
				Object(preact_min["h"])(
					match["Link"],
					{ activeClassName: header_style_default.a.active, href: '/' },
					'\u7F57\u535A\u6DF1\u9996\u9875'
				),
				Object(preact_min["h"])(
					match["Link"],
					{ activeClassName: header_style_default.a.active, href: '/about' },
					'\u8C01\u662F\u7F57\u535A\u6DF1?'
				),
				Object(preact_min["h"])(
					match["Link"],
					{ activeClassName: header_style_default.a.active, href: '/#activities' },
					'\u7F57\u535A\u6DF1\u5728\u4E2D\u56FD'
				)
			)
		);
	};

	return Header;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/box/Box.js
var Box = __webpack_require__("BVH1");

// EXTERNAL MODULE: ./components/typography/heading/Heading.js
var Heading = __webpack_require__("bnN1");

// EXTERNAL MODULE: ./components/typography/text/Text.js
var Text = __webpack_require__("JT19");

// EXTERNAL MODULE: ./assets/images/Wechat1.svg
var Wechat1 = __webpack_require__("ASFD");
var Wechat1_default = /*#__PURE__*/__webpack_require__.n(Wechat1);

// EXTERNAL MODULE: ./components/footer/style.css
var footer_style = __webpack_require__("ZMjw");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// EXTERNAL MODULE: ./assets/images/Weibo.svg
var Weibo = __webpack_require__("ZhQQ");
var Weibo_default = /*#__PURE__*/__webpack_require__.n(Weibo);

// EXTERNAL MODULE: ./assets/images/Zhihu.svg
var Zhihu = __webpack_require__("Ind5");
var Zhihu_default = /*#__PURE__*/__webpack_require__.n(Zhihu);

// EXTERNAL MODULE: ./assets/images/QR_code.jpg
var QR_code = __webpack_require__("dkkB");
var QR_code_default = /*#__PURE__*/__webpack_require__.n(QR_code);

// CONCATENATED MODULE: ./components/footer/index.js


function footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var footer__ref = Object(preact_min["h"])(
    Box["a" /* default */],
    { marginBottom: '20px' },
    Object(preact_min["h"])(
        Heading["a" /* default */],
        { size: 'lg', accessibilityLevel: 3, color: 'white' },
        '\u5176\u4ED6\u5185\u5BB9'
    )
);

var footer__ref2 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white', fontWeight: 'bold' },
    '\u7F57\u535A\u6DF1\u9996\u9875'
);

var footer__ref3 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white', fontWeight: 'bold' },
    '\u8C01\u662F\u7F57\u535A\u6DF1'
);

var footer__ref4 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white', fontWeight: 'bold' },
    '\u7F57\u535A\u6DF1\u5728\u4E2D\u56FD'
);

var _ref5 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white' },
    '\u8BAD\u7EC3\u8425\u8BFE\u7A0B'
);

var footer__ref6 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white' },
    '\u89C6\u9891\u8BFE\u7A0B'
);

var _ref7 = Object(preact_min["h"])(
    'span',
    { style: 'padding-left: 150px; padding-right: 110px; line-weight: 5px' },
    '\xA0'
);

var footer__ref8 = Object(preact_min["h"])(
    Box["a" /* default */],
    { marginBottom: '20px', justify: 'flex-start' },
    Object(preact_min["h"])(
        Heading["a" /* default */],
        { size: 'lg', accessibilityLevel: 3, color: 'white' },
        '\u8054\u7CFB\u6211\u4EEC'
    )
);

var footer__ref9 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white' },
    '\u5546\u52A1\u5408\u4F5C\u90AE\u7BB1\uFF1Apartnership@expii.com'
);

var _ref10 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'white' },
    '\u8BFE\u7A0B\u54A8\u8BE2\u95EE\u9898\uFF1Aboshuzhushou1(\u5FAE\u4FE1\u53F7)'
);

var _ref11 = Object(preact_min["h"])(
    'span',
    { style: 'padding-left: 150px; padding-right: 110px; line-weight: 5px' },
    '\xA0'
);

var _ref12 = Object(preact_min["h"])(
    Box["a" /* default */],
    { marginBottom: '20px' },
    Object(preact_min["h"])(
        Heading["a" /* default */],
        { size: 'lg', accessibilityLevel: 3, color: 'white' },
        '\u5173\u6CE8\u6211\u4EEC'
    )
);

var _ref13 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'black', textAlign: 'center' },
    '\u626B\u7801\u5173\u6CE8'
);

var _ref14 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'lightgray' },
    '\u5FAE\u4FE1\u516C\u4F17\u53F7'
);

var _ref15 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'lightgray' },
    '\u65B0\u6D6A\u5FAE\u535A'
);

var _ref16 = Object(preact_min["h"])(
    Text["a" /* default */],
    { color: 'lightgray' },
    '\u77E5\u4E4E'
);

var _ref17 = Object(preact_min["h"])(Box["a" /* default */], null);

var footer_Footer = function (_Component) {
    footer__inherits(Footer, _Component);

    function Footer() {
        footer__classCallCheck(this, Footer);

        return footer__possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Footer.prototype.render = function render() {
        var iconStyles = { width: '67px', height: '67px', borderRadius: '50%', color: 'white' };
        var imgStyles = { width: '200px', height: '200px', marginLeft: '7px' };
        var linkStyles = { minWidth: '90px', textDecoration: 'none', paddingBottom: '5px', marginRight: '5px' };
        return Object(preact_min["h"])(
            'footer',
            { 'class': footer_style_default.a.footer },
            Object(preact_min["h"])(
                'div',
                { 'class': footer_style_default.a.text, style: 'margin-right: 8%' },
                footer__ref,
                Object(preact_min["h"])(
                    Box["a" /* default */],
                    { direction: 'column' },
                    Object(preact_min["h"])(
                        'a',
                        { href: '#', style: linkStyles },
                        footer__ref2
                    ),
                    Object(preact_min["h"])(
                        'a',
                        { href: '/about', style: linkStyles },
                        footer__ref3
                    ),
                    Object(preact_min["h"])(
                        'a',
                        { href: '/#activities', style: linkStyles },
                        footer__ref4
                    ),
                    Object(preact_min["h"])(
                        'a',
                        { href: 'http://join-tsinghua.edu.cn/publish/bzw/7545/2018/20180615162335858871445/20180615162335858871445_.html', style: linkStyles, target: '_blank' },
                        _ref5
                    ),
                    Object(preact_min["h"])(
                        'a',
                        { href: '/courses', style: linkStyles },
                        footer__ref6
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': footer_style_default.a.displayLine },
                _ref7
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': footer_style_default.a.text },
                footer__ref8,
                Object(preact_min["h"])(
                    Box["a" /* default */],
                    { direction: 'column' },
                    Object(preact_min["h"])(
                        'div',
                        { style: linkStyles },
                        footer__ref9
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { style: linkStyles },
                        _ref10
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': footer_style_default.a.displayLine },
                _ref11
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': footer_style_default.a.text },
                Object(preact_min["h"])(
                    'div',
                    { 'class': footer_style_default.a.thirdColumn },
                    _ref12
                ),
                Object(preact_min["h"])(
                    Box["a" /* default */],
                    null,
                    Object(preact_min["h"])(
                        'div',
                        { 'class': footer_style_default.a.rightMostIcons },
                        Object(preact_min["h"])(
                            'a',
                            { href: 'https://image.ibb.co/f5qBry/QR_code.jpg', style: linkStyles, 'class': footer_style_default.a.tooltip },
                            Object(preact_min["h"])(
                                'span',
                                { 'class': footer_style_default.a.tooltiptext },
                                Object(preact_min["h"])('img', { src: QR_code_default.a, 'class': footer_style_default.a.QRcodeImage }),
                                _ref13
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': footer_style_default.a.thirdColumn },
                                Object(preact_min["h"])(
                                    Box["a" /* default */],
                                    { direction: 'column', align: 'center' },
                                    Object(preact_min["h"])('img', { src: Wechat1_default.a, style: iconStyles }),
                                    _ref14
                                )
                            )
                        ),
                        Object(preact_min["h"])(
                            'a',
                            { href: 'https://www.weibo.com/poshenloh', style: linkStyles, target: '_blank' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': footer_style_default.a.thirdColumn },
                                Object(preact_min["h"])(
                                    Box["a" /* default */],
                                    { direction: 'column', align: 'center' },
                                    Object(preact_min["h"])('img', { src: Weibo_default.a, style: iconStyles }),
                                    _ref15
                                )
                            )
                        ),
                        Object(preact_min["h"])(
                            'a',
                            { href: 'https://www.zhihu.com/people/po-shen-loh/activities', style: linkStyles, target: '_blank' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': footer_style_default.a.thirdColumn },
                                Object(preact_min["h"])(
                                    Box["a" /* default */],
                                    { direction: 'column', align: 'center' },
                                    Object(preact_min["h"])('img', { src: Zhihu_default.a, style: iconStyles }),
                                    _ref16
                                )
                            )
                        )
                    )
                )
            ),
            _ref17
        );
    };

    return Footer;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/about/index.js

		

		function about_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("LOGg") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var about = (async_default()(about_load));
	
// CONCATENATED MODULE: ./routes/courses/index.js

		

		function courses_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("R1y+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var courses = (async_default()(courses_load));
	
// EXTERNAL MODULE: ./routes/courses/course/style.css
var course_style = __webpack_require__("neLX");
var course_style_default = /*#__PURE__*/__webpack_require__.n(course_style);

// EXTERNAL MODULE: ./components/horizontal-scroller/style.css
var horizontal_scroller_style = __webpack_require__("RloS");
var horizontal_scroller_style_default = /*#__PURE__*/__webpack_require__.n(horizontal_scroller_style);

// CONCATENATED MODULE: ./components/horizontal-scroller/index.js


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function horizontal_scroller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function horizontal_scroller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function horizontal_scroller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function indexOfClosest(num, arr) {
  var mid = void 0;
  var lo = 0;
  var hi = arr.length - 1;
  while (hi - lo > 1) {
    mid = Math.floor((lo + hi) / 2);
    if (arr[mid] < num) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  if (num - arr[lo] <= arr[hi] - num) {
    return lo;
  }
  return hi;
}
var getTime = Date.now || function getTime() {
  return new Date().getTime();
};
function momentum(current, start, time, deceleration) {
  var distance = current - start,
      speed = Math.abs(distance) / time,
      destination = void 0,
      duration = void 0;

  deceleration = deceleration === undefined ? 0.0006 : deceleration;

  destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
  duration = speed / deceleration;

  return {
    destination: Math.round(destination),
    duration: duration
  };
};
function windowWidth() {
  var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;
  return x;
}
var scrollEvents = ["scroll", "wheel", "DOMMouseScroll", "MozMousePixelScroll", "touchstart", "touchmove", "touchend"];

var horizontal_scroller__ref = Object(preact_min["h"])(
  'svg',
  { width: '16px', height: '28px', viewBox: '0 0 16 28', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
  Object(preact_min["h"])(
    'desc',
    null,
    'Created with Sketch.'
  ),
  Object(preact_min["h"])('defs', null),
  Object(preact_min["h"])(
    'g',
    { id: 'Final-Screens', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd', 'stroke-linecap': 'round' },
    Object(preact_min["h"])(
      'g',
      { id: 'Desktop-Final-Prototype-3', transform: 'translate(-84.000000, -2922.000000)', stroke: '#364959', 'stroke-width': '3' },
      Object(preact_min["h"])(
        'g',
        { id: 'Group-3', transform: 'translate(65.000000, 2907.000000)' },
        Object(preact_min["h"])('path', { d: 'M33.2180858,16.9363008 L21.4974044,28.6569822 C21.1068801,29.0475065 21.1068801,29.6806715 21.4974044,30.0711958 C21.5001824,30.0739737 21.5029768,30.0767353 21.5057873,30.0794804 L33.2180858,41.5189006', id: 'Path-2' })
      )
    )
  )
);

var horizontal_scroller__ref2 = Object(preact_min["h"])(
  'svg',
  { width: '16px', height: '28px', viewBox: '0 0 16 28', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
  Object(preact_min["h"])(
    'desc',
    null,
    'Created with Sketch.'
  ),
  Object(preact_min["h"])('defs', null),
  Object(preact_min["h"])(
    'g',
    { id: 'Final-Screens', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd', 'stroke-linecap': 'round' },
    Object(preact_min["h"])(
      'g',
      { id: 'Desktop-Final-Prototype-3', transform: 'translate(-1267.000000, -2922.000000)', stroke: '#364959', 'stroke-width': '3' },
      Object(preact_min["h"])(
        'g',
        { id: 'Group-3-Copy', transform: 'translate(1273.000000, 2936.000000) scale(-1, 1) translate(-1273.000000, -2936.000000) translate(1244.000000, 2907.000000)' },
        Object(preact_min["h"])('path', { d: 'M33.2180858,16.9363008 L21.4974044,28.6569822 C21.1068801,29.0475065 21.1068801,29.6806715 21.4974044,30.0711958 C21.5001824,30.0739737 21.5029768,30.0767353 21.5057873,30.0794804 L33.2180858,41.5189006', id: 'Path-2' })
      )
    )
  )
);

var horizontal_scroller_HorizontalScroller = function (_Component) {
  horizontal_scroller__inherits(HorizontalScroller, _Component);

  //corresponds with xs breakpoint in css

  function HorizontalScroller(props) {
    horizontal_scroller__classCallCheck(this, HorizontalScroller);

    var _this = horizontal_scroller__possibleConstructorReturn(this, _Component.call(this, props));

    _this.snapPoints = [];
    _this.onScrollTimeout = null;
    _this.stopAnimationTimeout = null;
    _this.animationTime = 500;
    _this.desktopNumToShow = 3;
    _this.mobileNumToShow = 1;
    _this.mobileBreakPoint = 825;

    _this.state = {
      startMousePosition: 0,
      scrollPosition: 0,
      draggingThumb: false,
      scrollParentLeft: 0,
      scrollParentWidth: 0,
      thumbWidth: 0,
      defaultFontSize: 16,
      scrollSnapPointIndex: 0,
      snapPointsLength: 0,
      isAnimating: false,
      isSnapping: false,
      isMobile: false,
      startY: 0,
      startX: 0,
      disableScroll: false
    };

    _this.onDragThumb = _this.onDragThumb.bind(_this);
    _this.setThumbStart = _this.setThumbStart.bind(_this);
    _this.dragEndThumb = _this.dragEndThumb.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.resize = _this.resize.bind(_this);
    _this.jumpToNearestSnap = _this.jumpToNearestSnap.bind(_this);
    _this.nextThree = _this.nextThree.bind(_this);
    _this.lastThree = _this.lastThree.bind(_this);
    _this.snapToSnapIndex = _this.snapToSnapIndex.bind(_this);
    _this.animate = _this.animate.bind(_this);

    return _this;
  }

  HorizontalScroller.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };

    this.rAF = this.rAF ? this.rAF.bind(window) : this.rAF;
    scrollEvents.forEach(function (type) {
      _this2.itemsContainer.addEventListener(type, _this2.onScroll, false);
    });
    window.addEventListener("resize", this.resize, false);
    this.resize();
  };

  HorizontalScroller.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        itemsGenerator = _props.itemsGenerator,
        thisProps = _objectWithoutProperties(_props, ['itemsGenerator']);

    var nextItemGen = nextProps.itemsGenerator,
        nextPropsModified = _objectWithoutProperties(nextProps, ['itemsGenerator']);
    // this.setState({ scrollPosition: 0 });
    // this.resize();

  };

  HorizontalScroller.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.draggingThumb && !prevState.draggingThumb) {
      document.addEventListener("mousemove", this.onDragThumb);
      document.addEventListener("mouseup", this.dragEndThumb);
    } else if (!this.state.draggingThumb && prevState.draggingThumb) {
      document.removeEventListener("mousemove", this.onDragThumb);
      document.removeEventListener("mouseup", this.dragEndThumb);
      this.jumpToNearestSnap();
    }
  };

  HorizontalScroller.prototype.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    document.removeEventListener("mousemove", this.onDragThumb);
    document.removeEventListener("mouseup", this.dragEndThumb);
    scrollEvents.forEach(function (type) {
      _this3.itemsContainer.removeEventListener(type, _this3.onScroll, false);
    });
    window.removeEventListener("resize", this.resize, false);
  };

  HorizontalScroller.prototype.resize = function resize(e) {
    var _this4 = this;

    var parentRect = this.thumb.parentElement.getBoundingClientRect();
    var scrollParentLeft = parentRect.left;
    var scrollParentWidth = parentRect.width;
    var style = window.getComputedStyle(this.thumb.parentElement);
    var defaultFontSize = parseInt(style.getPropertyValue("font-size").slice(0, -2));
    var prevMobile = this.state.isMobile;

    this.setState({
      thumbWidth: this.thumb.getBoundingClientRect().width,
      scrollParentLeft: scrollParentLeft,
      scrollParentWidth: scrollParentWidth,
      defaultFontSize: defaultFontSize,
      isMobile: windowWidth() <= this.mobileBreakPoint
    }, function () {
      if (_this4.state.isMobile && !prevMobile) {
        _this4.resize();
      }
      _this4.generateScrollSnapPoints();
    });
  };

  HorizontalScroller.prototype.generateScrollSnapPoints = function generateScrollSnapPoints() {
    var _state = this.state,
        defaultFontSize = _state.defaultFontSize,
        thumbWidth = _state.thumbWidth,
        scrollParentWidth = _state.scrollParentWidth,
        isMobile = _state.isMobile;
    var _props2 = this.props,
        itemsLength = _props2.itemsLength,
        gutterWidth = _props2.gutterWidth;

    this.snapPoints = [];
    var numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    var newGutterWidth = isMobile ? gutterWidth / 2 : gutterWidth;
    if (itemsLength > numToShow) {
      var actualCardWidth = isMobile ? scrollParentWidth / numToShow - newGutterWidth * defaultFontSize : scrollParentWidth / numToShow - newGutterWidth / (numToShow / (numToShow - 1)) * defaultFontSize;

      var scale = function scale(x) {
        var a = 0;
        var b = scrollParentWidth - thumbWidth;
        var min = 0;
        var max = 0 - actualCardWidth * (itemsLength - numToShow) - newGutterWidth * defaultFontSize * (itemsLength - numToShow);
        return parseFloat((b - a) * (x - min) / (max - min) + a);
      };
      for (var tempScrollPosition = 0; tempScrollPosition < scrollParentWidth - thumbWidth; tempScrollPosition -= scale(actualCardWidth + newGutterWidth * defaultFontSize) * numToShow) {
        this.snapPoints.push(tempScrollPosition);
      }
      this.snapPoints.push(scrollParentWidth - thumbWidth);
    }
    this.setState({
      snapPointsLength: this.snapPoints.length
    });
  };

  HorizontalScroller.prototype.setThumbStart = function setThumbStart(e) {
    if (e.button !== 0) return;
    var rect = this.thumb.getBoundingClientRect();
    var left = rect.left + document.body.scrollLeft - this.state.scrollParentLeft;
    this.setState({
      startMousePosition: e.pageX - left,
      draggingThumb: true
    });
    e.stopPropagation();
    e.preventDefault();
  };

  HorizontalScroller.prototype.onDragThumb = function onDragThumb(e) {
    if (!this.state.draggingThumb) return;

    var scrollPosition = Math.min(Math.max(0, e.pageX - this.state.startMousePosition), this.state.scrollParentWidth - this.state.thumbWidth);
    this.setState({
      scrollPosition: scrollPosition
    });
    e.stopPropagation();
    e.preventDefault();
  };

  HorizontalScroller.prototype.dragEndThumb = function dragEndThumb(e) {
    this.setState({ draggingThumb: false });
    e.stopPropagation();
    e.preventDefault();
  };

  HorizontalScroller.prototype.onScroll = function onScroll(e) {
    var itemsLength = this.props.itemsLength;
    var isMobile = this.state.isMobile;

    var numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    if (itemsLength > numToShow && !this.state.isSnapping) {
      if (e.type === "touchstart") {
        this.onTouchStart(e);
      } else if (e.type === "touchmove") {
        this.onTouchMove(e);
      } else if (e.type === "touchend") {
        this.onTouchEnd(e);
      } else {
        this.onMouse(e);
      }
    }
  };

  HorizontalScroller.prototype.onTouchStart = function onTouchStart(e) {
    var _state2 = this.state,
        isMobile = _state2.isMobile,
        isAnimating = _state2.isAnimating;

    var numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    var touch = e.changedTouches[0];
    var scrollPosition = this.state.startMousePosition + touch.pageX / this.props.itemsLength * numToShow;
    if (isAnimating) {
      e.stopPropagation();
      e.preventDefault();
    }
    this.setState({
      startMousePosition: scrollPosition,
      startX: touch.pageX,
      startScroll: getTime(),
      isAnimating: false,
      isDragging: true
    });
  };

  HorizontalScroller.prototype.onTouchMove = function onTouchMove(e) {
    var _state3 = this.state,
        isMobile = _state3.isMobile,
        disableScroll = _state3.disableScroll,
        startX = _state3.startX;

    var numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    var touch = e.changedTouches[0];
    var scrollPosition = Math.min(Math.max(0, this.state.startMousePosition - touch.pageX / this.props.itemsLength * numToShow), this.state.scrollParentWidth - this.state.thumbWidth);
    var timeStamp = getTime();
    this.setState({
      scrollPosition: scrollPosition
    });
    if (timeStamp - this.state.startScroll > 500) {
      this.setState({
        startScroll: timeStamp,
        startX: touch.pageX
      });
    }
    e.preventDefault();
    e.stopPropagation();
  };

  HorizontalScroller.prototype.onTouchEnd = function onTouchEnd(e) {
    var _this5 = this;

    var handleTouchEnd = function handleTouchEnd() {
      if (!_this5.state.isDragging) {
        _this5.jumpToNearestSnap();
        _this5.setState({
          startMousePosition: _this5.state.scrollPosition,
          startX: _this5.state.scrollPosition
        });
      }
    };

    this.setState({
      isDragging: false
    });
    var touch = e.changedTouches[0];
    var duration = getTime() - this.state.startScroll;
    if (duration < 500) {
      var m = momentum(touch.pageX, this.state.startX, duration, 0.0006);
      this.animate(m.destination, m.duration, handleTouchEnd);
    } else {
      handleTouchEnd();
    }
  };

  HorizontalScroller.prototype.onMouse = function onMouse(e) {
    var _this6 = this;

    if (e.deltaX) {
      var delta = e.deltaX;
      var scrollPosition = Math.min(Math.max(0, this.state.scrollPosition + delta), this.state.scrollParentWidth - this.state.thumbWidth);
      this.setState({
        scrollPosition: scrollPosition
      });
      clearTimeout(this.onScrollTimeout);
      this.onScrollTimeout = setTimeout(function () {
        _this6.jumpToNearestSnap();
      }, 500);
      e.stopPropagation();
      e.preventDefault();
    }
  };

  HorizontalScroller.prototype.snapToSnapIndex = function snapToSnapIndex(index) {
    var _this7 = this;

    this.setState({
      isSnapping: true
    }, function () {
      _this7.setState({
        scrollPosition: _this7.snapPoints[index],
        startMousePosition: _this7.snapPoints[index],
        scrollSnapPointIndex: index
      }, function () {
        clearTimeout(_this7.stopAnimationTimeout);
        _this7.stopAnimationTimeout = setTimeout(function () {
          _this7.setState({
            isSnapping: false
          });
        }, _this7.animationTime);
      });
    });
  };

  HorizontalScroller.prototype.jumpToNearestSnap = function jumpToNearestSnap() {
    var indexOfNearestScroll = indexOfClosest(this.state.scrollPosition, this.snapPoints);
    this.snapToSnapIndex(indexOfNearestScroll);
  };

  HorizontalScroller.prototype.nextThree = function nextThree() {
    if (this.state.scrollSnapPointIndex + 1 < this.snapPoints.length) {
      this.snapToSnapIndex(this.state.scrollSnapPointIndex + 1);
    }
  };

  HorizontalScroller.prototype.lastThree = function lastThree() {
    if (this.state.scrollSnapPointIndex - 1 > -1) {
      this.snapToSnapIndex(this.state.scrollSnapPointIndex - 1);
    }
  };

  HorizontalScroller.prototype.animate = function animate(destX, duration, cb) {
    var _this8 = this;

    var startX = this.state.scrollPosition,
        startMousePosition = this.state.startMousePosition,
        startTime = getTime(),
        destTime = startTime + duration,
        easingFn = function easingFn(k) {
      return Math.sqrt(1 - --k * k);
    };
    var numToShow = this.state.isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    var step = function step() {
      if (!_this8.state.isAnimating) {
        cb();
        return;
      }
      var now = getTime(),
          newX = void 0,
          easing = void 0;
      if (now >= destTime) {
        _this8.setState({
          isAnimating: false
        });
        cb();
        return;
      }

      now = (now - startTime) / duration;
      easing = easingFn(now);

      var destXAdjusted = Math.min(Math.max(0, startMousePosition - destX / _this8.props.itemsLength * numToShow), _this8.state.scrollParentWidth - _this8.state.thumbWidth);
      newX = (destXAdjusted - startX) * easing + startX;
      _this8.setState({
        scrollPosition: newX,
        startMousePosition: newX,
        isAnimating: !(_this8.state.scrollPosition === 0 || _this8.state.scrollPosition === _this8.state.scrollParentWidth - _this8.state.thumbWidth)
      });
      if (_this8.state.isAnimating) {
        _this8.rAF(step);
      } else {
        cb();
        return;
      }
    };

    this.setState({
      isAnimating: true
    });
    step();
  };

  HorizontalScroller.prototype.render = function render() {
    var _this9 = this;

    var _props3 = this.props,
        itemsGenerator = _props3.itemsGenerator,
        itemsLength = _props3.itemsLength,
        itemWidth = _props3.itemWidth,
        gutterWidth = _props3.gutterWidth,
        withColor = _props3.withColor;
    var _state4 = this.state,
        scrollPosition = _state4.scrollPosition,
        defaultFontSize = _state4.defaultFontSize,
        thumbWidth = _state4.thumbWidth,
        scrollParentWidth = _state4.scrollParentWidth,
        isAnimating = _state4.isAnimating,
        isSnapping = _state4.isSnapping,
        scrollSnapPointIndex = _state4.scrollSnapPointIndex,
        snapPointsLength = _state4.snapPointsLength,
        isMobile = _state4.isMobile;


    var itemStyles = {
      flexBasis: '',
      flexShrink: 0,
      width: '',
      marginRight: '',
      marginLeft: ''
    };
    var itemsStyle = {
      marginLeft: '',
      transform: '',
      transition: ''
    };
    var scrollerContainerStyle = {
      overflowX: 'initial',
      maxWidth: '100%',
      margin: '',
      padding: ''
    };
    var scrollerStyle = {
      width: '100%',
      maxWidth: '',
      margin: '',
      position: 'relative'
    };

    var numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow;
    var newGutterWidth = isMobile ? gutterWidth / 2 : gutterWidth;
    var actualCardWidth = isMobile ? scrollParentWidth / numToShow - newGutterWidth * defaultFontSize : scrollParentWidth / numToShow - newGutterWidth / (numToShow / (numToShow - 1)) * defaultFontSize;

    var scale = function scale(x) {
      var min = 0;
      var max = scrollParentWidth - thumbWidth;
      if (max === 0) {
        //number of elements is 1, just apply the correct margin
        return 0;
      }
      var a = 0;
      var b = 0 - actualCardWidth * (itemsLength - numToShow) - newGutterWidth * defaultFontSize * (itemsLength - numToShow);
      return parseFloat((b - a) * (x - min) / (max - min) + a);
    };
    itemsStyle.marginLeft = scale(scrollPosition) + 'px';

    itemStyles.flexBasis = actualCardWidth + 'px';
    itemStyles.width = actualCardWidth + 'px';
    itemStyles.marginRight = newGutterWidth + 'rem';

    scrollerStyle.margin = 'auto';

    scrollerContainerStyle.overflowX = 'hidden';
    scrollerContainerStyle.margin = 'auto';

    if (isMobile) {
      scrollerContainerStyle.padding = '0 5vw';
      itemStyles.marginRight = newGutterWidth / 2 + 'rem';
      itemStyles.marginLeft = newGutterWidth / 2 + 'rem';
    }
    var thumbStyle = {
      width: numToShow / itemsLength * 100 + '%',
      marginLeft: scrollPosition + 'px',
      transition: ''
    };

    if (isSnapping) {
      itemsStyle.transition = 'margin-left ' + this.animationTime / 1000 + 's ease';
      thumbStyle.transition = 'margin-left ' + this.animationTime / 1000 + 's ease';
    }

    var thumbClassNames = [horizontal_scroller_style_default.a.horizontalscroller__thumb];
    return Object(preact_min["h"])(
      'div',
      {
        'class': horizontal_scroller_style_default.a.horizontalscroller,
        style: scrollerStyle,
        ref: function ref(itemsContainer) {
          _this9.itemsContainer = itemsContainer;
        } },
      Object(preact_min["h"])(
        'div',
        { style: scrollSnapPointIndex > 0 ? {} : { display: 'none' }, 'class': [horizontal_scroller_style_default.a.horizontalscroller__arrow, horizontal_scroller_style_default.a.horizontalscroller__arrow_left].join(' '), onClick: this.lastThree },
        horizontal_scroller__ref
      ),
      Object(preact_min["h"])(
        'div',
        { style: scrollSnapPointIndex < snapPointsLength - 1 ? {} : { display: 'none' }, 'class': [horizontal_scroller_style_default.a.horizontalscroller__arrow, horizontal_scroller_style_default.a.horizontalscroller__arrow_right].join(' '), onClick: this.nextThree },
        horizontal_scroller__ref2
      ),
      Object(preact_min["h"])(
        'div',
        { style: scrollerContainerStyle, 'class': horizontal_scroller_style_default.a.horizontalscroller__container },
        Object(preact_min["h"])(
          'div',
          {
            style: itemsStyle,

            'class': horizontal_scroller_style_default.a.horizontalscroller__items
          },
          itemsGenerator(itemStyles)
        ),
        Object(preact_min["h"])(
          'div',
          {
            ref: function ref(scrollerbar) {
              _this9.scrollerbar = scrollerbar;
            },
            'class': horizontal_scroller_style_default.a.horizontalscroller__bar,
            style: itemsLength < numToShow ? {
              opacity: 0
            } : null
          },
          Object(preact_min["h"])('div', {
            style: thumbStyle,
            draggable: 'true',
            onDragStart: this.setThumbStart,
            ref: function ref(thumb) {
              _this9.thumb = thumb;
            },
            className: thumbClassNames.join(" ")
          })
        )
      )
    );
  };

  return HorizontalScroller;
}(preact_min["Component"]);

/* harmony default export */ var horizontal_scroller = (horizontal_scroller_HorizontalScroller);
// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ../node_modules/preact-portal/dist/preact-portal.js
var preact_portal = __webpack_require__("q6qL");
var preact_portal_default = /*#__PURE__*/__webpack_require__.n(preact_portal);

// EXTERNAL MODULE: ./routes/courses/data/courses.json
var data_courses = __webpack_require__("gkyg");
var courses_default = /*#__PURE__*/__webpack_require__.n(data_courses);

// EXTERNAL MODULE: ./assets/images/down-caret.png
var down_caret = __webpack_require__("V5Lr");
var down_caret_default = /*#__PURE__*/__webpack_require__.n(down_caret);

// EXTERNAL MODULE: ./assets/images/arrow-down.svg
var arrow_down = __webpack_require__("qzhV");
var arrow_down_default = /*#__PURE__*/__webpack_require__.n(arrow_down);

// CONCATENATED MODULE: ./routes/courses/course/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function course__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function course__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function course__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var course_Popup = function Popup(_ref) {
  var open = _ref.open,
      _ref$into = _ref.into,
      into = _ref$into === undefined ? "body" : _ref$into,
      children = _ref.children,
      closeModal = _ref.closeModal;
  return Object(preact_min["h"])(
    preact_portal_default.a,
    { into: into },
    Object(preact_min["h"])(
      'div',
      { 'class': open ? [course_style_default.a.modalOverlay, course_style_default.a.modalOverlayToggled].join(' ') : course_style_default.a.modalOverlay, onClick: function onClick(e) {
          e.stopPropagation();
          closeModal();
        } },
      Object(preact_min["h"])(
        'div',
        { 'class': open ? [course_style_default.a.modal, course_style_default.a.modalToggled].join(' ') : course_style_default.a.modal, onClick: function onClick(e) {
            e.stopPropagation();
          } },
        children
      )
    )
  );
};
var course_CloseButton = function CloseButton(_ref2) {
  var onClick = _ref2.onClick;
  return Object(preact_min["h"])('button', { 'class': course_style_default.a.closeButton, onClick: onClick });
};
var course_VideoModal = function VideoModal(_ref3) {
  var title = _ref3.title,
      longDescription = _ref3.longDescription,
      url = _ref3.url,
      buyUrl = _ref3.buyUrl,
      closeModal = _ref3.closeModal;
  return Object(preact_min["h"])(
    'div',
    { 'class': course_style_default.a.videoModal },
    Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.videoTopBar },
      Object(preact_min["h"])(
        Heading["a" /* default */],
        {
          size: 'sm',
          fontWeight: 'bold',
          accessibilityLevel: 4 },
        title
      ),
      Object(preact_min["h"])(course_CloseButton, { onClick: closeModal })
    ),
    Object(preact_min["h"])('iframe', {
      src: url,
      id: 'viewerIframe',
      allowfullscreen: '',
      webkitallowfullscreen: '',
      'class': course_style_default.a.popUpVideo
    }),
    Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.videoBottomBar },
      Object(preact_min["h"])(
        'div',
        { 'class': course_style_default.a.videoDescription },
        Object(preact_min["h"])(
          Text["a" /* default */],
          null,
          longDescription
        )
      ),
      Object(preact_min["h"])(
        components_button["a" /* default */],
        { href: buyUrl },
        '\u8D2D\u4E70\u8BFE\u7A0B'
      )
    )
  );
};

var course__ref5 = Object(preact_min["h"])('div', null);

var course_ReviewModal = function ReviewModal(_ref4) {
  var name = _ref4.name,
      school = _ref4.school,
      content = _ref4.content,
      closeModal = _ref4.closeModal;
  return Object(preact_min["h"])(
    'div',
    { 'class': course_style_default.a.reviewModal },
    Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.reviewTopBar },
      course__ref5,
      Object(preact_min["h"])(course_CloseButton, { onClick: closeModal })
    ),
    Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.reviewContentModal },
      Object(preact_min["h"])(
        Box["a" /* default */],
        { direction: 'column', marginBottom: '10px' },
        Object(preact_min["h"])(
          Text["a" /* default */],
          null,
          name
        ),
        Object(preact_min["h"])(
          Text["a" /* default */],
          { size: 'sm' },
          school
        )
      ),
      Object(preact_min["h"])(
        Text["a" /* default */],
        null,
        content
      )
    )
  );
};

var course_HeaderItem = function (_Component) {
  course__inherits(HeaderItem, _Component);

  function HeaderItem() {
    course__classCallCheck(this, HeaderItem);

    return course__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  HeaderItem.prototype.render = function render() {
    var items = courses_default.a;
    var displayItem = items.map(function (item, index) {
      return Object(preact_min["h"])(
        'div',
        { key: index, 'class': course_style_default.a.singleItem },
        Object(preact_min["h"])(
          'div',
          { 'class': course_style_default.a.tooltip },
          item.title,
          Object(preact_min["h"])(
            'span',
            { 'class': course_style_default.a.tooltiptext },
            Object(preact_min["h"])(
              'div',
              { 'class': course_style_default.a.courseTitle },
              item.courses.map(function (content, cIndex) {
                return Object(preact_min["h"])(
                  'a',
                  { key: cIndex, 'class': course_style_default.a.courseContent, style: 'margin: 0 0 0 0; height: 55px', href: '/courses/' + index + '/' + cIndex },
                  Object(preact_min["h"])(
                    'p',
                    { 'class': course_style_default.a.courseText },
                    content.title
                  )
                );
              })
            )
          )
        ),
        Object(preact_min["h"])('img', { src: arrow_down_default.a, 'class': course_style_default.a.icon })
      );
    });
    return Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.items },
      displayItem
    );
  };

  return HeaderItem;
}(preact_min["Component"]);

var course__ref7 = Object(preact_min["h"])(course_HeaderItem, null);

var course_StickyHeader = function (_Component2) {
  course__inherits(StickyHeader, _Component2);

  function StickyHeader() {
    course__classCallCheck(this, StickyHeader);

    return course__possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  StickyHeader.prototype.componentDidMount = function componentDidMount() {
    this.rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };

    this.rAF = this.rAF ? this.rAF.bind(window) : this.rAF;
    this.scrollTo = this.scrollTo.bind(this);
    //this.previewLinkPos = this.previewLink.getBoundingClientRect().left;
  };

  StickyHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.previewToggled != this.props.previewToggled) {
      if (this.props.previewToggled) {
        this.scrollTo(this.previewLinkPos, 600);
      } else {
        this.scrollTo(0, 600);
      }
    }
  };

  StickyHeader.prototype.easeInOutQuad = function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  StickyHeader.prototype.scrollTo = function scrollTo(to, duration) {
    var _this3 = this;

    var start = this.stickyPageLinks.scrollLeft,
        change = to - start,
        currentTime = Date.now();

    var animateScroll = function animateScroll() {
      var millis = Date.now() - currentTime;
      var val = _this3.easeInOutQuad(millis, start, change, duration);
      _this3.stickyPageLinks.scroll(val, 0);
      if (millis < duration) {
        _this3.rAF(animateScroll);
      }
    };
    this.rAF(animateScroll);
  };

  StickyHeader.prototype.render = function render(_ref6) {
    var _this4 = this;

    var blockIndex = _ref6.blockIndex,
        courseIndex = _ref6.courseIndex,
        buyUrl = _ref6.buyUrl,
        stickyToggled = _ref6.stickyToggled,
        previewToggled = _ref6.previewToggled;

    return Object(preact_min["h"])(
      'div',
      { 'class': stickyToggled ? [header_style_default.a.header, course_style_default.a.stickyMenu, course_style_default.a.stickyMenuToggled].join(' ') : [header_style_default.a.header, course_style_default.a.stickyMenu].join(' ') },
      Object(preact_min["h"])(
        'nav',
        null,
        Object(preact_min["h"])(
          'div',
          { 'class': course_style_default.a.stickyPageLinks, ref: function ref(node) {
              return _this4.stickyPageLinks = node;
            } },
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.headerDisplay },
            course__ref7
          )
        ),
        Object(preact_min["h"])(
          'a',
          { 'class': course_style_default.a.buyCourse, href: buyUrl, target: '_blank' },
          '\u8D2D\u4E70\u8BFE\u7A0B'
        )
      )
    );
  };

  return StickyHeader;
}(preact_min["Component"]);

var course__ref10 = Object(preact_min["h"])(
  'svg',
  { width: '48px', height: '47px', viewBox: '0 0 48 47', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
  Object(preact_min["h"])('defs', null),
  Object(preact_min["h"])(
    'g',
    { id: 'Final-Screens', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
    Object(preact_min["h"])(
      'g',
      { id: 'Desktop-Final-Prototype-3', transform: 'translate(-526.000000, -3583.000000)' },
      Object(preact_min["h"])(
        'g',
        { id: 'Video-Sample-1', transform: 'translate(394.000000, 3515.000000)' },
        Object(preact_min["h"])(
          'g',
          { id: 'Group-8', transform: 'translate(132.804194, 68.266826)' },
          Object(preact_min["h"])('circle', { id: 'Oval-2', fill: '#EEEEEE', cx: '23.2781245', cy: '23.2781245', r: '23.2781245' }),
          Object(preact_min["h"])('polygon', { id: 'Triangle', fill: '#D8D8D8', points: '32.664465 23.2781245 17.6463201 32.2890113 17.6463201 14.2672376' })
        )
      )
    )
  )
);

var course_Course = function (_Component3) {
  course__inherits(Course, _Component3);

  function Course(props) {
    course__classCallCheck(this, Course);

    var _this5 = course__possibleConstructorReturn(this, _Component3.call(this, props));

    _this5.state = {
      modalOpen: false,
      modalType: '',
      modalProps: {},
      stickyToggled: false,
      previewNavToggled: false
    };


    _this5.openModal = _this5.openModal.bind(_this5);
    _this5.closeModal = _this5.closeModal.bind(_this5);
    _this5.escapeKeyPressed = _this5.escapeKeyPressed.bind(_this5);
    _this5.toggleStickyPadding = _this5.toggleStickyPadding.bind(_this5);
    _this5.togglePreviewActive = _this5.togglePreviewActive.bind(_this5);
    return _this5;
  }

  Course.prototype.componentDidMount = function componentDidMount() {
    //this.previewScreenPos = this.preview.getBoundingClientRect().top;
    window.addEventListener('keydown', this.escapeKeyPressed, false);
    window.addEventListener('scroll', this.toggleStickyPadding, false);
    window.addEventListener('scroll', this.togglePreviewActive, false);
    this.toggleStickyPadding();
    this.togglePreviewActive();
  };

  Course.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.escapeKeyPressed, false);
    window.removeEventListener('scroll', this.toggleStickyPadding, false);
    window.removeEventListener('scroll', this.togglePreviewActive, false);
  };

  Course.prototype.escapeKeyPressed = function escapeKeyPressed(e) {
    if (e.key === 'Escape') {
      this.closeModal();
    }
  };

  Course.prototype.openModal = function openModal(type, props) {
    this.setState({
      modalOpen: true,
      modalType: type,
      modalProps: props
    });
  };

  Course.prototype.closeModal = function closeModal() {
    this.setState({
      modalOpen: false
    });
  };

  Course.prototype.togglePreviewActive = function togglePreviewActive() {
    if (window.scrollY >= this.previewScreenPos - 60) {
      this.setState({
        previewNavToggled: false
      });
    } else {
      this.setState({
        previewNavToggled: false
      });
    }
  };

  Course.prototype.toggleStickyPadding = function toggleStickyPadding() {
    if (window.scrollY >= 140) {
      this.setState({
        stickyToggled: true
      });
    } else {
      this.setState({
        stickyToggled: false
      });
    }
  };

  Course.prototype.render = function render(_ref8, _ref9) {
    var _this6 = this;

    var matches = _ref8.matches;
    var modalOpen = _ref9.modalOpen,
        modalType = _ref9.modalType,
        modalProps = _ref9.modalProps,
        stickyToggled = _ref9.stickyToggled,
        previewNavToggled = _ref9.previewNavToggled;

    var widthProps = {
      maxWidth: '580px',
      width: '100%'
    };
    var containerProps = {
      paddingX: '20px',
      paddingY: '35px',
      justify: 'center'
    };
    var blockIndex = matches.blockIndex,
        courseIndex = matches.courseIndex;

    var course = courses_default.a[parseInt(blockIndex, 10)].courses[parseInt(courseIndex, 10)];
    var reviewGenerator = function reviewGenerator(inlineStyle) {
      return course.reviews.map(function (r) {
        var content = r.content.length >= 125 ? r.content.substring(0, 125).trim() + '...' : r.content;
        return Object(preact_min["h"])(
          'div',
          { style: inlineStyle, 'class': course_style_default.a.reviewCard, onClick: function onClick() {
              return _this6.openModal('review', r);
            } },
          Object(preact_min["h"])(
            Box["a" /* default */],
            { marginBottom: '10px', direction: 'column' },
            Object(preact_min["h"])(
              Text["a" /* default */],
              null,
              r.name
            ),
            Object(preact_min["h"])(
              Text["a" /* default */],
              { size: 'sm' },
              r.school
            )
          ),
          Object(preact_min["h"])(
            Text["a" /* default */],
            null,
            content
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.readMore },
            '\u9605\u8BFB\u66F4\u591A',
            Object(preact_min["h"])('img', { src: down_caret_default.a, 'class': course_style_default.a.downCaret })
          )
        );
      });
    };
    var videoGenerator = function videoGenerator(inlineStyle) {
      return course.videos.map(function (v) {
        return Object(preact_min["h"])(
          'div',
          { style: inlineStyle, 'class': course_style_default.a.videoCard, onClick: function onClick() {
              return _this6.openModal('video', v);
            } },
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.videoPreview },
            course__ref10,
            Object(preact_min["h"])('img', { src: '/static/courses/' + v.previewImg, alt: v.previewAlt })
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.videoData },
            Object(preact_min["h"])(
              Heading["a" /* default */],
              { size: 'md', accessibilityLevel: 4 },
              v.title
            ),
            Object(preact_min["h"])(
              Text["a" /* default */],
              null,
              v.shortDescription
            )
          )
        );
      });
    };
    return Object(preact_min["h"])(
      'div',
      { 'class': course_style_default.a.course },
      Object(preact_min["h"])(
        course_Popup,
        { open: modalOpen, closeModal: this.closeModal },
        modalType === 'video' ? Object(preact_min["h"])(course_VideoModal, _extends({}, modalProps, { buyUrl: course.buyUrl, closeModal: this.closeModal })) : Object(preact_min["h"])(course_ReviewModal, _extends({}, modalProps, { closeModal: this.closeModal }))
      ),
      Object(preact_min["h"])(course_StickyHeader, { blockIndex: blockIndex, courseIndex: courseIndex, buyUrl: course.buyUrl, stickyToggled: stickyToggled, previewToggled: previewNavToggled }),
      Object(preact_min["h"])(
        Box["a" /* default */],
        _extends({}, containerProps, { align: 'center' }),
        Object(preact_min["h"])(
          Box["a" /* default */],
          { maxWidth: '580px', width: '100%', justify: 'center', align: 'center', direction: 'column' },
          Object(preact_min["h"])(
            Heading["a" /* default */],
            { size: 'lg', accessibilityLevel: 1 },
            course.title
          )
        )
      ),
      Object(preact_min["h"])('a', { name: 'preview', ref: function ref(node) {
          return _this6.preview = node;
        } }),
      Object(preact_min["h"])(
        Box["a" /* default */],
        _extends({}, containerProps, {
          color: course.blocks.length % 2 == 0 ? 'white' : 'gray',
          direction: 'column',
          align: 'center',
          className: course_style_default.a.scrollerContainer }),
        Object(preact_min["h"])(horizontal_scroller, {
          itemsGenerator: videoGenerator,
          itemsLength: course.videos.length,
          gutterWidth: 1.5
        })
      ),
      course.blocks.map(function (b, index) {
        return Object(preact_min["h"])(
          Box["a" /* default */],
          _extends({}, containerProps, { color: index == 3 ? 'white' : 'gray', direction: 'column', align: 'center' }),
          Object(preact_min["h"])(
            Box["a" /* default */],
            _extends({}, widthProps, { direction: 'column', align: 'left' }),
            Object(preact_min["h"])(
              Heading["a" /* default */],
              { size: 'md', accessibilityLevel: 2 },
              b.title
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.classContent },
            Object(preact_min["h"])(
              Box["a" /* default */],
              _extends({}, widthProps, { marginTop: '10px', display: 'flex' }),
              Object(preact_min["h"])(
                Text["a" /* default */],
                { columnCount: index == 3 ? 2 : 1, columnGap: index == 3 ? 60 : 0 },
                b.content
              )
            )
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': course_style_default.a.classContentMobile },
            Object(preact_min["h"])(
              Box["a" /* default */],
              _extends({}, widthProps, { marginTop: '10px', display: 'block' }),
              Object(preact_min["h"])(
                Text["a" /* default */],
                null,
                b.content
              )
            )
          )
        );
      })
    );
  };

  return Course;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/mobile-header/style.css
var mobile_header_style = __webpack_require__("2S6C");
var mobile_header_style_default = /*#__PURE__*/__webpack_require__.n(mobile_header_style);

// CONCATENATED MODULE: ./components/mobile-header/index.js


function mobile_header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mobile_header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mobile_header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var mobile_header__ref3 = Object(preact_min["h"])('div', null);

var mobile_header__ref4 = Object(preact_min["h"])('div', null);

var mobile_header__ref5 = Object(preact_min["h"])('div', null);

var mobile_header_MobileHeader = function (_Component) {
  mobile_header__inherits(MobileHeader, _Component);

  function MobileHeader() {
    var _temp, _this, _ret;

    mobile_header__classCallCheck(this, MobileHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = mobile_header__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isToggled: false
    }, _this.toggleMobileMenu = function (e) {
      _this.setState({ isToggled: !_this.state.isToggled });
    }, _this.disableMobileMenu = function (e) {
      if (_this.state.isToggled) {
        _this.setState({ isToggled: false });
      }
    }, _temp), mobile_header__possibleConstructorReturn(_this, _ret);
  }

  MobileHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (!this.state.isToggled) {
      document.documentElement.style.width = "101%";
      setTimeout(function () {
        document.documentElement.style.width = "100%"; // hack to correct width thing
      }, 300);
    }
  };

  MobileHeader.prototype.render = function render(_ref, _ref2) {
    var _this2 = this;

    var children = _ref.children;
    var isToggled = _ref2.isToggled;

    var mobileMenuClasses = [mobile_header_style_default.a.mobileMenu];
    var contentClasses = [mobile_header_style_default.a.contentContainer];
    var hamburgerClasses = [mobile_header_style_default.a.hamburger];
    var hamburgerContainer = [mobile_header_style_default.a.hamburgerContainer];
    var mobileHeaderContainer = [mobile_header_style_default.a.mobileHeaderContainer];
    if (isToggled) {
      mobileMenuClasses.push(mobile_header_style_default.a.mobileMenuToggled);
      contentClasses.push(mobile_header_style_default.a.contentContainerToggled);
      hamburgerClasses.push(mobile_header_style_default.a.hamburgerToggled);
      hamburgerContainer.push(mobile_header_style_default.a.hamburgerContainerToggled);
      mobileHeaderContainer.push(mobile_header_style_default.a.mobileHeaderContainerToggled);
    }
    return Object(preact_min["h"])(
      'div',
      { 'class': mobileHeaderContainer.join(' ') },
      Object(preact_min["h"])(
        'div',
        { 'class': mobileMenuClasses.join(' ') },
        Object(preact_min["h"])(
          'nav',
          null,
          Object(preact_min["h"])(
            match["Link"],
            { activeClassName: mobile_header_style_default.a.active, href: '/', onClick: this.disableMobileMenu },
            '\u7F57\u535A\u6DF1\u9996\u9875'
          ),
          Object(preact_min["h"])(
            match["Link"],
            { activeClassName: mobile_header_style_default.a.active, href: '/about', onClick: this.disableMobileMenu },
            '\u8C01\u662F\u7F57\u535A\u6DF1?'
          ),
          Object(preact_min["h"])(
            match["Link"],
            { activeClassName: mobile_header_style_default.a.active, href: '/#activities', onClick: this.disableMobileMenu },
            '\u7F57\u535A\u6DF1\u5728\u4E2D\u56FD'
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': hamburgerContainer.join(' ') },
        Object(preact_min["h"])(
          'button',
          { 'class': hamburgerClasses.join(' '), onClick: this.toggleMobileMenu },
          mobile_header__ref3,
          mobile_header__ref4,
          mobile_header__ref5
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': contentClasses.join(' '), ref: function ref(node) {
            return _this2.content = node;
          } },
        children
      )
    );
  };

  return MobileHeader;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// import Home from 'async!../routes/home';
// import Profile from 'async!../routes/profile';

if (false) {
	require('preact/debug');
}

var app__ref = Object(preact_min["h"])(header_Header, null);

var app__ref2 = Object(preact_min["h"])(home, { path: '/' });

var app__ref3 = Object(preact_min["h"])(about, { path: '/about' });

var app__ref4 = Object(preact_min["h"])(courses, { path: '/courses' });

var app__ref5 = Object(preact_min["h"])(course_Course, { path: '/courses/:blockIndex/:courseIndex' });

var app__ref6 = Object(preact_min["h"])(footer_Footer, null);

var app_App = function (_Component) {
	app__inherits(App, _Component);

	/** Gets fired when the route changes.
  *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
  *	@param {string} event.url	The newly routed URL
  */
	function App(props) {
		app__classCallCheck(this, App);

		var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleRoute = function (e) {
			if (typeof window !== "undefined") {
				window.scrollTo(0, 0);
			}
			_this.currentUrl = e.url;
			mixpanel_cjs_default.a.track('pageview');
		};

		mixpanel_cjs_default.a.init("3e7916a6e65e76ae49e4f9984b1ff3a5");
		return _this;
	}

	App.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ id: 'app' },
			app__ref,
			Object(preact_min["h"])(
				mobile_header_MobileHeader,
				null,
				Object(preact_min["h"])(
					'div',
					{ id: 'content' },
					Object(preact_min["h"])(
						preact_router_es["Router"],
						{ onChange: this.handleRoute },
						app__ref2,
						app__ref3,
						app__ref4,
						app__ref5
					)
				),
				app__ref6
			)
		);
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index_0 = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "RloS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"horizontalscroller":"horizontalscroller__2HP2c","horizontalscroller__container":"horizontalscroller__container__hkPGz","horizontalscroller__items":"horizontalscroller__items__COM2B","horizontalscroller__bar":"horizontalscroller__bar__2oNJ8","horizontalscroller__thumb":"horizontalscroller__thumb__2WzHP","horizontalscroller__arrow":"horizontalscroller__arrow__33yaw","horizontalscroller__arrow_left":"horizontalscroller__arrow_left__iabmT","horizontalscroller__arrow_right":"horizontalscroller__arrow_right__3Ffgr"};

/***/ }),

/***/ "V5Lr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0436cdb61f0aebd48fd620638169bfad.png";

/***/ }),

/***/ "W4AX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heading":"heading__3tysZ","xs":"xs__2-Spr","sm":"sm__1kN-G","md":"md__3n-J3","lg":"lg__uCPk2","xl":"xl__3eFGf"};

/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","text":"text__ltW01","rightMostIcons":"rightMostIcons__2dPLf","thirdColumn":"thirdColumn__WLAsm","tooltip":"tooltip__23XHt","tooltiptext":"tooltiptext__RPVYE","displayLine":"displayLine__1AeYf","QRcodeImage":"QRcodeImage__2ttfZ"};

/***/ }),

/***/ "ZhQQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc9fe2c2ee7200c365259f1230a73f9d.svg";

/***/ }),

/***/ "bMV/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Config = {
    DEBUG: false,
    LIB_VERSION: '2.22.4'
};

// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var window$1;
if (typeof window === 'undefined') {
    var loc = {
        hostname: ''
    };
    window$1 = {
        navigator: { userAgent: '' },
        document: {
            location: loc,
            referrer: ''
        },
        screen: { width: 0, height: 0 },
        location: loc
    };
} else {
    window$1 = window;
}

/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */

var ArrayProto = Array.prototype;
var FuncProto = Function.prototype;
var ObjProto = Object.prototype;
var slice = ArrayProto.slice;
var toString = ObjProto.toString;
var hasOwnProperty = ObjProto.hasOwnProperty;
var windowConsole = window$1.console;
var navigator$1 = window$1.navigator;
var document$1 = window$1.document;
var windowOpera = window$1.opera;
var screen = window$1.screen;
var userAgent = navigator$1.userAgent;
var nativeBind = FuncProto.bind;
var nativeForEach = ArrayProto.forEach;
var nativeIndexOf = ArrayProto.indexOf;
var nativeIsArray = Array.isArray;
var breaker = {};
var _ = {
    trim: function trim(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};

// Console override
var console$1 = {
    /** @type {function(...[*])} */
    log: function log() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            try {
                windowConsole.log.apply(windowConsole, arguments);
            } catch (err) {
                _.each(arguments, function (arg) {
                    windowConsole.log(arg);
                });
            }
        }
    },
    /** @type {function(...[*])} */
    error: function error() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function (arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...[*])} */
    critical: function critical() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function (arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};

// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function (func, context) {
    var args, _bound;
    if (nativeBind && func.bind === nativeBind) {
        return nativeBind.apply(func, slice.call(arguments, 1));
    }
    if (!_.isFunction(func)) {
        throw new TypeError();
    }
    args = slice.call(arguments, 2);
    _bound = function bound() {
        if (!(this instanceof _bound)) {
            return func.apply(context, args.concat(slice.call(arguments)));
        }
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
            return result;
        }
        return self;
    };
    return _bound;
};

_.bind_instance_methods = function (obj) {
    for (var func in obj) {
        if (typeof obj[func] === 'function') {
            obj[func] = _.bind(obj[func], obj);
        }
    }
};

/**
 * @param {*=} obj
 * @param {function(...[*])=} iterator
 * @param {Object=} context
 */
_.each = function (obj, iterator, context) {
    if (obj === null || obj === undefined) {
        return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
                return;
            }
        }
    } else {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) {
                    return;
                }
            }
        }
    }
};

_.escapeHTML = function (s) {
    var escaped = s;
    if (escaped && _.isString(escaped)) {
        escaped = escaped.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
    return escaped;
};

_.extend = function (obj) {
    _.each(slice.call(arguments, 1), function (source) {
        for (var prop in source) {
            if (source[prop] !== void 0) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

_.isArray = nativeIsArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function (f) {
    try {
        return (/^\s*\bfunction\b/.test(f)
        );
    } catch (x) {
        return false;
    }
};

_.isArguments = function (obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
};

_.toArray = function (iterable) {
    if (!iterable) {
        return [];
    }
    if (iterable.toArray) {
        return iterable.toArray();
    }
    if (_.isArray(iterable)) {
        return slice.call(iterable);
    }
    if (_.isArguments(iterable)) {
        return slice.call(iterable);
    }
    return _.values(iterable);
};

_.keys = function (obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function (value, key) {
        results[results.length] = key;
    });
    return results;
};

_.values = function (obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function (value) {
        results[results.length] = value;
    });
    return results;
};

_.identity = function (value) {
    return value;
};

_.include = function (obj, target) {
    var found = false;
    if (obj === null) {
        return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
        return obj.indexOf(target) != -1;
    }
    _.each(obj, function (value) {
        if (found || (found = value === target)) {
            return breaker;
        }
    });
    return found;
};

_.includes = function (str, needle) {
    return str.indexOf(needle) !== -1;
};

// Underscore Addons
_.inherit = function (subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};

_.isObject = function (obj) {
    return obj === Object(obj) && !_.isArray(obj);
};

_.isEmptyObject = function (obj) {
    if (_.isObject(obj)) {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

_.isUndefined = function (obj) {
    return obj === void 0;
};

_.isString = function (obj) {
    return toString.call(obj) == '[object String]';
};

_.isDate = function (obj) {
    return toString.call(obj) == '[object Date]';
};

_.isNumber = function (obj) {
    return toString.call(obj) == '[object Number]';
};

_.isElement = function (obj) {
    return !!(obj && obj.nodeType === 1);
};

_.encodeDates = function (obj) {
    _.each(obj, function (v, k) {
        if (_.isDate(v)) {
            obj[k] = _.formatDate(v);
        } else if (_.isObject(v)) {
            obj[k] = _.encodeDates(v); // recurse
        }
    });
    return obj;
};

_.timestamp = function () {
    Date.now = Date.now || function () {
        return +new Date();
    };
    return Date.now();
};

_.formatDate = function (d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};

_.safewrap = function (f) {
    return function () {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if (Config.DEBUG) {
                console$1.critical(e);
            }
        }
    };
};

_.safewrap_class = function (klass, functions) {
    for (var i = 0; i < functions.length; i++) {
        klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
    }
};

_.safewrap_instance_methods = function (obj) {
    for (var func in obj) {
        if (typeof obj[func] === 'function') {
            obj[func] = _.safewrap(obj[func]);
        }
    }
};

_.strip_empty_properties = function (p) {
    var ret = {};
    _.each(p, function (v, k) {
        if (_.isString(v) && v.length > 0) {
            ret[k] = v;
        }
    });
    return ret;
};

/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */
_.truncate = function (obj, length) {
    var ret;

    if (typeof obj === 'string') {
        ret = obj.slice(0, length);
    } else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function (val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function (val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else {
        ret = obj;
    }

    return ret;
};

_.JSONEncode = function () {
    return function (mixed_val) {
        var value = mixed_val;
        var quote = function quote(string) {
            var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = { // table of character substitutions
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };

            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };

        var str = function str(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];

            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') {
                value = value.toJSON(key);
            }

            // What happens next depends on the value's type.
            switch (typeof value) {
                case 'string':
                    return quote(value);

                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.

                    return String(value);

                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                        return 'null';
                    }

                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];

                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.

                        length = value.length;
                        for (i = 0; i < length; i += 1) {
                            partial[i] = str(i, value) || 'null';
                        }

                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }

                    // Iterate through all of the keys in the object.
                    for (k in value) {
                        if (hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }

                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };

        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();

/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */
_.JSONDecode = function () {
    var at,
        // The index of the current character
    ch,
        // The current character
    escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    },
        text,
        error = function error(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    },
        next = function next(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) {
            error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        }
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    },
        number = function number() {
        // Parse a number value.
        var number,
            string = '';

        if (ch === '-') {
            string = '-';
            next('-');
        }
        while (ch >= '0' && ch <= '9') {
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while (next() && ch >= '0' && ch <= '9') {
                string += ch;
            }
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) {
            error('Bad number');
        } else {
            return number;
        }
    },
        string = function string() {
        // Parse a string value.
        var hex,
            i,
            string = '',
            uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') {
            while (next()) {
                if (ch === '"') {
                    next();
                    return string;
                }
                if (ch === '\\') {
                    next();
                    if (ch === 'u') {
                        uffff = 0;
                        for (i = 0; i < 4; i += 1) {
                            hex = parseInt(next(), 16);
                            if (!isFinite(hex)) {
                                break;
                            }
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    } else if (typeof escapee[ch] === 'string') {
                        string += escapee[ch];
                    } else {
                        break;
                    }
                } else {
                    string += ch;
                }
            }
        }
        error('Bad string');
    },
        white = function white() {
        // Skip whitespace.
        while (ch && ch <= ' ') {
            next();
        }
    },
        word = function word() {
        // true, false, or null.
        switch (ch) {
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    },
        value,
        // Placeholder for the value function.
    array = function array() {
        // Parse an array value.
        var array = [];

        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while (ch) {
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    },
        object = function object() {
        // Parse an object value.
        var key,
            object = {};

        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while (ch) {
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) {
                    error('Duplicate key "' + key + '"');
                }
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };

    value = function value() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function (source) {
        var result;

        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error('Syntax error');
        }

        return result;
    };
}();

_.base64Encode = function (data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1,
        o2,
        o3,
        h1,
        h2,
        h3,
        h4,
        bits,
        i = 0,
        ac = 0,
        enc = '',
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data = _.utf8Encode(data);

    do {
        // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
};

_.utf8Encode = function (string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;

        if (c1 < 128) {
            end++;
        } else if (c1 > 127 && c1 < 2048) {
            enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        } else {
            enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }

    if (end > start) {
        utftext += string.substring(start, string.length);
    }

    return utftext;
};

_.UUID = function () {

    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function T() {
        var d = 1 * new Date(),
            i = 0;

        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while (d == 1 * new Date()) {
            i++;
        }

        return d.toString(16) + i.toString(16);
    };

    // Math.Random entropy
    var R = function R() {
        return Math.random().toString(16).replace('.', '');
    };

    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function UA() {
        var ua = userAgent,
            i,
            ch,
            buffer = [],
            ret = 0;

        function xor(result, byte_array) {
            var j,
                tmp = 0;
            for (j = 0; j < byte_array.length; j++) {
                tmp |= buffer[j] << j * 8;
            }
            return result ^ tmp;
        }

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function () {
        var se = (screen.height * screen.width).toString(16);
        return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
    };
}();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
_.isBlockedUA = function (ua) {
    if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
        return true;
    }
    return false;
};

/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */
_.HTTPBuildQuery = function (formdata, arg_separator) {
    var use_val,
        use_key,
        tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
        arg_separator = '&';
    }

    _.each(formdata, function (val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });

    return tmp_arr.join(arg_separator);
};

_.getQueryParam = function (url, param) {
    // Expects a raw URL

    param = param.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) {
        return '';
    } else {
        return decodeURIComponent(results[1]).replace(/\+/g, ' ');
    }
};

_.getHashParam = function (hash, param) {
    var matches = hash.match(new RegExp(param + '=([^&]*)'));
    return matches ? matches[1] : null;
};

// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function get(name) {
        var nameEQ = name + '=';
        var ca = document$1.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },

    parse: function parse(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
            // noop
        }
        return cookie;
    },

    set_seconds: function set_seconds(name, value, seconds, cross_subdomain, is_secure) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (cross_subdomain) {
            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
                domain = matches ? matches[0] : '';

            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }

        if (is_secure) {
            secure = '; secure';
        }

        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },

    set: function set(name, value, days, cross_subdomain, is_secure) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (cross_subdomain) {
            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
                domain = matches ? matches[0] : '';

            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toGMTString();
        }

        if (is_secure) {
            secure = '; secure';
        }

        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },

    remove: function remove(name, cross_subdomain) {
        _.cookie.set(name, '', -1, cross_subdomain);
    }
};

// _.localStorage
var _localStorage_supported = null;
_.localStorage = {
    is_supported: function is_supported() {
        if (_localStorage_supported !== null) {
            return _localStorage_supported;
        }

        var supported = true;
        try {
            var key = '__mplssupport__',
                val = 'xyz';
            _.localStorage.set(key, val);
            if (_.localStorage.get(key) !== val) {
                supported = false;
            }
            _.localStorage.remove(key);
        } catch (err) {
            supported = false;
        }
        if (!supported) {
            console$1.error('localStorage unsupported; falling back to cookie store');
        }

        _localStorage_supported = supported;
        return supported;
    },

    error: function error(msg) {
        console$1.error('localStorage error: ' + msg);
    },

    get: function get(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
        return null;
    },

    parse: function parse(name) {
        try {
            return _.JSONDecode(_.localStorage.get(name)) || {};
        } catch (err) {
            // noop
        }
        return null;
    },

    set: function set(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            _.localStorage.error(err);
        }
    },

    remove: function remove(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
    }
};

_.register_event = function () {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...[*])} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */
    var register_event = function register_event(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console$1.error('No valid element provided to register_event');
            return;
        }

        if (element.addEventListener && !oldSchool) {
            element.addEventListener(type, handler, !!useCapture);
        } else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };

    function makeHandler(element, new_handler, old_handlers) {
        var handler = function handler(event) {
            event = event || fixEvent(window.event);

            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) {
                return undefined;
            }

            var ret = true;
            var old_result, new_result;

            if (_.isFunction(old_handlers)) {
                old_result = old_handlers(event);
            }
            new_result = new_handler.call(element, event);

            if (false === old_result || false === new_result) {
                ret = false;
            }

            return ret;
        };

        return handler;
    }

    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function () {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function () {
        this.cancelBubble = true;
    };

    return register_event;
}();

_.dom_query = function () {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:
     elements = document.getElementsBySelector('div#main p a.external')
     Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"
     New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors
     Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails
     Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */

    function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }

    var bad_whitespace = /[\t\r\n]/g;

    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }

    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document$1.getElementsByTagName) {
            return [];
        }
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [document$1];
        for (i = 0; i < tokens.length; i++) {
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) {
                    // element not found or tag with that ID not found, return false
                    return [];
                }
                // Set currentContext to contain just this element
                currentContext = [element];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) {
                    tagName = '*';
                }
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (found[j].className && _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                    hasClass(found[j], className)) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) {
                    tagName = '*';
                }
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch (attrOperator) {
                    case '=':
                        // Equality
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        // Match one of space seperated words
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        // Match start with value followed by optional hyphen
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        // Match starts with value
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        // Match ends with value - fails with "Warning" in Opera 7
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        // Match ends with value
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (checkFunction(found[j])) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for (j = 0; j < currentContext.length; j++) {
                elements = currentContext[j].getElementsByTagName(tagName);
                for (k = 0; k < elements.length; k++) {
                    found[foundCount++] = elements[k];
                }
            }
            currentContext = found;
        }
        return currentContext;
    }

    return function (query) {
        if (_.isElement(query)) {
            return [query];
        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
            return query;
        } else {
            return getElementsBySelector.call(this, query);
        }
    };
}();

_.info = {
    campaignParams: function campaignParams() {
        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
            kw = '',
            params = {};
        _.each(campaign_keywords, function (kwkey) {
            kw = _.getQueryParam(document$1.URL, kwkey);
            if (kw.length) {
                params[kwkey] = kw;
            }
        });

        return params;
    },

    searchEngine: function searchEngine(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'google';
        } else if (referrer.search('https?://(.*)bing.com') === 0) {
            return 'bing';
        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
            return 'yahoo';
        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
            return 'duckduckgo';
        } else {
            return null;
        }
    },

    searchInfo: function searchInfo(referrer) {
        var search = _.info.searchEngine(referrer),
            param = search != 'yahoo' ? 'q' : 'p',
            ret = {};

        if (search !== null) {
            ret['$search_engine'] = search;

            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) {
                ret['mp_keyword'] = keyword;
            }
        }

        return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function browser(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) {
                return 'Opera Mini';
            }
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
            return 'Internet Explorer Mobile';
        } else if (_.includes(user_agent, 'Edge')) {
            return 'Microsoft Edge';
        } else if (_.includes(user_agent, 'FBIOS')) {
            return 'Facebook Mobile';
        } else if (_.includes(user_agent, 'Chrome')) {
            return 'Chrome';
        } else if (_.includes(user_agent, 'CriOS')) {
            return 'Chrome iOS';
        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
            return 'UC Browser';
        } else if (_.includes(user_agent, 'FxiOS')) {
            return 'Firefox iOS';
        } else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) {
                return 'Mobile Safari';
            }
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) {
            return 'Android Mobile';
        } else if (_.includes(user_agent, 'Konqueror')) {
            return 'Konqueror';
        } else if (_.includes(user_agent, 'Firefox')) {
            return 'Firefox';
        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
            return 'Internet Explorer';
        } else if (_.includes(user_agent, 'Gecko')) {
            return 'Mozilla';
        } else {
            return '';
        }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function browserVersion(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) {
            return null;
        }
        var matches = userAgent.match(regex);
        if (!matches) {
            return null;
        }
        return parseFloat(matches[matches.length - 2]);
    },

    os: function os() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
                return 'Windows Phone';
            }
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) {
            return 'iOS';
        } else if (/Android/.test(a)) {
            return 'Android';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
            return 'BlackBerry';
        } else if (/Mac/i.test(a)) {
            return 'Mac OS X';
        } else if (/Linux/.test(a)) {
            return 'Linux';
        } else if (/CrOS/.test(a)) {
            return 'Chrome OS';
        } else {
            return '';
        }
    },

    device: function device(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
            return 'Windows Phone';
        } else if (/iPad/.test(user_agent)) {
            return 'iPad';
        } else if (/iPod/.test(user_agent)) {
            return 'iPod Touch';
        } else if (/iPhone/.test(user_agent)) {
            return 'iPhone';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (/Android/.test(user_agent)) {
            return 'Android';
        } else {
            return '';
        }
    },

    referringDomain: function referringDomain(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) {
            return split[2];
        }
        return '';
    },

    properties: function properties() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
            '$referrer': document$1.referrer,
            '$referring_domain': _.info.referringDomain(document$1.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': window$1.location.href,
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': Config.LIB_VERSION
        });
    },

    people_properties: function people_properties() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera)
        });
    },

    pageviewInfo: function pageviewInfo(page) {
        return _.strip_empty_properties({
            'mp_page': page,
            'mp_referrer': document$1.referrer,
            'mp_browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
            'mp_platform': _.info.os()
        });
    }
};

// EXPORTS (for closure compiler)
_['toArray'] = _.toArray;
_['isObject'] = _.isObject;
_['JSONEncode'] = _.JSONEncode;
_['JSONDecode'] = _.JSONDecode;
_['isBlockedUA'] = _.isBlockedUA;
_['isEmptyObject'] = _.isEmptyObject;
_['info'] = _.info;
_['info']['device'] = _.info.device;
_['info']['browser'] = _.info.browser;
_['info']['properties'] = _.info.properties;

/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */
function getClassName(el) {
    switch (typeof el.className) {
        case 'string':
            return el.className;
        case 'object':
            // handle cases where className might be SVGAnimatedString or some other type
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            // future proof
            return '';
    }
}

/*
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @returns {string} the element's direct text content
 */
function getSafeText(el) {
    var elText = '';

    if (shouldTrackElement(el) && el.childNodes && el.childNodes.length) {
        _.each(el.childNodes, function (child) {
            if (isTextNode(child) && child.textContent) {
                elText += _.trim(child.textContent)
                // scrub potentially sensitive values
                .split(/(\s+)/).filter(shouldTrackValue).join('')
                // normalize whitespace
                .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')
                // truncate
                .substring(0, 255);
            }
        });
    }

    return _.trim(elText);
}

/*
 * Check whether an element has nodeType Node.ELEMENT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isElementNode(el) {
    return el && el.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}

/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */
function isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}

/*
 * Check whether an element has nodeType Node.TEXT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isTextNode(el) {
    return el && el.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}

/*
 * Check whether a DOM event should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} event - event to check
 * @returns {boolean} whether the event should be tracked
 */
function shouldTrackDomEvent(el, event) {
    if (!el || isTag(el, 'html') || !isElementNode(el)) {
        return false;
    }
    var tag = el.tagName.toLowerCase();
    switch (tag) {
        case 'html':
            return false;
        case 'form':
            return event.type === 'submit';
        case 'input':
            if (['button', 'submit'].indexOf(el.getAttribute('type')) === -1) {
                return event.type === 'change';
            } else {
                return event.type === 'click';
            }
        case 'select':
        case 'textarea':
            return event.type === 'change';
        default:
            return event.type === 'click';
    }
}

/*
 * Check whether a DOM element should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackElement(el) {
    for (var curEl = el; curEl.parentNode && !isTag(curEl, 'body'); curEl = curEl.parentNode) {
        var classes = getClassName(curEl).split(' ');
        if (_.includes(classes, 'mp-sensitive') || _.includes(classes, 'mp-no-track')) {
            return false;
        }
    }

    if (_.includes(getClassName(el).split(' '), 'mp-include')) {
        return true;
    }

    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if (isTag(el, 'input') || isTag(el, 'select') || isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') {
        return false;
    }

    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') {
        // it's possible for el.type to be a DOM element if el is a form with a child input[name="type"]
        switch (type.toLowerCase()) {
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
    }

    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        // it's possible for el.name or el.id to be a DOM element if el is a form with a child input[name="name"]
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) {
            return false;
        }
    }

    return true;
}

/*
 * Check whether a string value should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackValue(value) {
    if (value === null || _.isUndefined(value)) {
        return false;
    }

    if (typeof value === 'string') {
        value = _.trim(value);

        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[\- ]/g, ''))) {
            return false;
        }

        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) {
            return false;
        }
    }

    return true;
}

var autotrack = {
    _initializedTokens: [],

    _previousElementSibling: function _previousElementSibling(el) {
        if (el.previousElementSibling) {
            return el.previousElementSibling;
        } else {
            do {
                el = el.previousSibling;
            } while (el && !isElementNode(el));
            return el;
        }
    },

    _loadScript: function _loadScript(scriptUrlToLoad, callback) {
        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = scriptUrlToLoad;
        scriptTag.onload = callback;

        var scripts = document.getElementsByTagName('script');
        if (scripts.length > 0) {
            scripts[0].parentNode.insertBefore(scriptTag, scripts[0]);
        } else {
            document.body.appendChild(scriptTag);
        }
    },

    _getPropertiesFromElement: function _getPropertiesFromElement(elem) {
        var props = {
            'classes': getClassName(elem).split(' '),
            'tag_name': elem.tagName.toLowerCase()
        };

        if (shouldTrackElement(elem)) {
            _.each(elem.attributes, function (attr) {
                if (shouldTrackValue(attr.value)) {
                    props['attr__' + attr.name] = attr.value;
                }
            });
        }

        var nthChild = 1;
        var nthOfType = 1;
        var currentElem = elem;
        while (currentElem = this._previousElementSibling(currentElem)) {
            // eslint-disable-line no-cond-assign
            nthChild++;
            if (currentElem.tagName === elem.tagName) {
                nthOfType++;
            }
        }
        props['nth_child'] = nthChild;
        props['nth_of_type'] = nthOfType;

        return props;
    },

    _getDefaultProperties: function _getDefaultProperties(eventType) {
        return {
            '$event_type': eventType,
            '$ce_version': 1,
            '$host': window.location.host,
            '$pathname': window.location.pathname
        };
    },

    _extractCustomPropertyValue: function _extractCustomPropertyValue(customProperty) {
        var propValues = [];
        _.each(document.querySelectorAll(customProperty['css_selector']), function (matchedElem) {
            var value;

            if (['input', 'select'].indexOf(matchedElem.tagName.toLowerCase()) > -1) {
                value = matchedElem['value'];
            } else if (matchedElem['textContent']) {
                value = matchedElem['textContent'];
            }

            if (shouldTrackValue(value)) {
                propValues.push(value);
            }
        });
        return propValues.join(', ');
    },

    _getCustomProperties: function _getCustomProperties(targetElementList) {
        var props = {};
        _.each(this._customProperties, function (customProperty) {
            _.each(customProperty['event_selectors'], function (eventSelector) {
                var eventElements = document.querySelectorAll(eventSelector);
                _.each(eventElements, function (eventElement) {
                    if (_.includes(targetElementList, eventElement) && shouldTrackElement(eventElement)) {
                        props[customProperty['name']] = this._extractCustomPropertyValue(customProperty);
                    }
                }, this);
            }, this);
        }, this);
        return props;
    },

    _getEventTarget: function _getEventTarget(e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/target#Compatibility_notes
        if (typeof e.target === 'undefined') {
            return e.srcElement;
        } else {
            return e.target;
        }
    },

    _trackEvent: function _trackEvent(e, instance) {
        /*** Don't mess with this code without running IE8 tests on it ***/
        var target = this._getEventTarget(e);
        if (isTextNode(target)) {
            // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
            target = target.parentNode;
        }

        if (shouldTrackDomEvent(target, e)) {
            var targetElementList = [target];
            var curEl = target;
            while (curEl.parentNode && !isTag(curEl, 'body')) {
                targetElementList.push(curEl.parentNode);
                curEl = curEl.parentNode;
            }

            var elementsJson = [];
            var href,
                explicitNoTrack = false;
            _.each(targetElementList, function (el) {
                var shouldTrackEl = shouldTrackElement(el);

                // if the element or a parent element is an anchor tag
                // include the href as a property
                if (el.tagName.toLowerCase() === 'a') {
                    href = el.getAttribute('href');
                    href = shouldTrackEl && shouldTrackValue(href) && href;
                }

                // allow users to programatically prevent tracking of elements by adding class 'mp-no-track'
                var classes = getClassName(el).split(' ');
                if (_.includes(classes, 'mp-no-track')) {
                    explicitNoTrack = true;
                }

                elementsJson.push(this._getPropertiesFromElement(el));
            }, this);

            if (explicitNoTrack) {
                return false;
            }

            // only populate text content from target element (not parents)
            // to prevent text within a sensitive element from being collected
            // as part of a parent's el.textContent
            var elementText;
            var safeElementText = getSafeText(target);
            if (safeElementText && safeElementText.length) {
                elementText = safeElementText;
            }

            var props = _.extend(this._getDefaultProperties(e.type), {
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$el_text': elementText
            }, this._getCustomProperties(targetElementList));

            instance.track('$web_event', props);
            return true;
        }
    },

    // only reason is to stub for unit tests
    // since you can't override window.location props
    _navigate: function _navigate(href) {
        window.location.href = href;
    },

    _addDomEventHandlers: function _addDomEventHandlers(instance) {
        var handler = _.bind(function (e) {
            e = e || window.event;
            this._trackEvent(e, instance);
        }, this);
        _.register_event(document, 'submit', handler, false, true);
        _.register_event(document, 'change', handler, false, true);
        _.register_event(document, 'click', handler, false, true);
    },

    _customProperties: {},
    init: function init(instance) {
        if (!(document && document.body)) {
            console.log('document not ready yet, trying again in 500 milliseconds...');
            var that = this;
            setTimeout(function () {
                that.init(instance);
            }, 500);
            return;
        }

        var token = instance.get_config('token');
        if (this._initializedTokens.indexOf(token) > -1) {
            console.log('autotrack already initialized for token "' + token + '"');
            return;
        }
        this._initializedTokens.push(token);

        if (!this._maybeLoadEditor(instance)) {
            // don't autotrack actions when the editor is enabled
            var parseDecideResponse = _.bind(function (response) {
                if (response && response['config'] && response['config']['enable_collect_everything'] === true) {

                    if (response['custom_properties']) {
                        this._customProperties = response['custom_properties'];
                    }

                    instance.track('$web_event', _.extend({
                        '$title': document.title
                    }, this._getDefaultProperties('pageview')));

                    this._addDomEventHandlers(instance);
                } else {
                    instance['__autotrack_enabled'] = false;
                }
            }, this);

            instance._send_request(instance.get_config('api_host') + '/decide/', {
                'verbose': true,
                'version': '1',
                'lib': 'web',
                'token': token
            }, instance._prepare_callback(parseDecideResponse));
        }
    },

    _editorParamsFromHash: function _editorParamsFromHash(instance, hash) {
        var editorParams;
        try {
            var state = _.getHashParam(hash, 'state');
            state = JSON.parse(decodeURIComponent(state));
            var expiresInSeconds = _.getHashParam(hash, 'expires_in');
            editorParams = {
                'accessToken': _.getHashParam(hash, 'access_token'),
                'accessTokenExpiresAt': new Date().getTime() + Number(expiresInSeconds) * 1000,
                'bookmarkletMode': !!state['bookmarkletMode'],
                'projectId': state['projectId'],
                'projectOwnerId': state['projectOwnerId'],
                'projectToken': state['token'],
                'readOnly': state['readOnly'],
                'userFlags': state['userFlags'],
                'userId': state['userId']
            };
            window.sessionStorage.setItem('editorParams', JSON.stringify(editorParams));

            if (state['desiredHash']) {
                window.location.hash = state['desiredHash'];
            } else if (window.history) {
                history.replaceState('', document.title, window.location.pathname + window.location.search); // completely remove hash
            } else {
                window.location.hash = ''; // clear hash (but leaves # unfortunately)
            }
        } catch (e) {
            console.error('Unable to parse data from hash', e);
        }
        return editorParams;
    },

    /**
     * To load the visual editor, we need an access token and other state. That state comes from one of three places:
     * 1. In the URL hash params if the customer is using an old snippet
     * 2. From session storage under the key `_mpcehash` if the snippet already parsed the hash
     * 3. From session storage under the key `editorParams` if the editor was initialized on a previous page
     */
    _maybeLoadEditor: function _maybeLoadEditor(instance) {
        try {
            var parseFromUrl = false;
            if (_.getHashParam(window.location.hash, 'state')) {
                var state = _.getHashParam(window.location.hash, 'state');
                state = JSON.parse(decodeURIComponent(state));
                parseFromUrl = state['action'] === 'mpeditor';
            }
            var parseFromStorage = !!window.sessionStorage.getItem('_mpcehash');
            var editorParams;

            if (parseFromUrl) {
                // happens if they are initializing the editor using an old snippet
                editorParams = this._editorParamsFromHash(instance, window.location.hash);
            } else if (parseFromStorage) {
                // happens if they are initialized the editor and using the new snippet
                editorParams = this._editorParamsFromHash(instance, window.sessionStorage.getItem('_mpcehash'));
                window.sessionStorage.removeItem('_mpcehash');
            } else {
                // get credentials from sessionStorage from a previous initialzation
                editorParams = JSON.parse(window.sessionStorage.getItem('editorParams') || '{}');
            }

            if (editorParams['projectToken'] && instance.get_config('token') === editorParams['projectToken']) {
                this._loadEditor(instance, editorParams);
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    },

    _loadEditor: function _loadEditor(instance, editorParams) {
        if (!window['_mpEditorLoaded']) {
            // only load the codeless event editor once, even if there are multiple instances of MixpanelLib
            window['_mpEditorLoaded'] = true;
            var editorUrl = instance.get_config('app_host') + '/js-bundle/reports/collect-everything/editor.js?_ts=' + new Date().getTime();
            this._loadScript(editorUrl, function () {
                window['mp_load_editor'](editorParams);
            });
            return true;
        }
        return false;
    },

    // this is a mechanism to ramp up CE with no server-side interaction.
    // when CE is active, every page load results in a decide request. we
    // need to gently ramp this up so we don't overload decide. this decides
    // deterministically if CE is enabled for this project by modding the char
    // value of the project token.
    enabledForProject: function enabledForProject(token, numBuckets, numEnabledBuckets) {
        numBuckets = !_.isUndefined(numBuckets) ? numBuckets : 10;
        numEnabledBuckets = !_.isUndefined(numEnabledBuckets) ? numEnabledBuckets : 10;
        var charCodeSum = 0;
        for (var i = 0; i < token.length; i++) {
            charCodeSum += token.charCodeAt(i);
        }
        return charCodeSum % numBuckets < numEnabledBuckets;
    },

    isBrowserSupported: function isBrowserSupported() {
        return _.isFunction(document.querySelectorAll);
    }
};

_.bind_instance_methods(autotrack);
_.safewrap_instance_methods(autotrack);

/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */

/** Public **/

var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';

/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function optIn(token, options) {
    _optInOut(true, token, options);
}

/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */
function optOut(token, options) {
    _optInOut(false, token, options);
}

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */
function hasOptedIn(token, options) {
    return _getStorageValue(token, options) === '1';
}

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted out of the given opt type
 */
function hasOptedOut(token, options) {
    if (_hasDoNotTrackFlagOn()) {
        return true;
    }
    return _getStorageValue(token, options) === '0';
}

/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelLib(method) {
    return _addOptOutCheck(method, function (name) {
        return this.get_config(name);
    });
}

/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelPeople(method) {
    return _addOptOutCheck(method, function (name) {
        return this._get_config(name);
    });
}

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function clearOptInOut(token, options) {
    options = options || {};
    _getStorage(options).remove(_getStorageKey(token, options), !!options.crossSubdomainCookie);
}

/** Private **/

/**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */
function _getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? _.localStorage : _.cookie;
}

/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */
function _getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}

/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */
function _getStorageValue(token, options) {
    return _getStorage(options).get(_getStorageKey(token, options));
}

/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @returns {boolean} whether the DNT setting is true
 */
function _hasDoNotTrackFlagOn() {
    return !!(window$1.navigator && window$1.navigator.doNotTrack === '1');
}

/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function _optInOut(optValue, token, options) {
    if (!_.isString(token) || !token.length) {
        console.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }

    options = options || {};

    _getStorage(options).set(_getStorageKey(token, options), optValue ? 1 : 0, _.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie);

    if (options.track && optValue) {
        // only track event if opting in (optValue=true)
        options.track(options.trackEventName || '$opt_in', options.trackProperties);
    }
}

/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function _addOptOutCheck(method, getConfigValue) {
    return function () {
        var optedOut = false;

        try {
            var token = getConfigValue.call(this, 'token');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');

            if (token) {
                // if there was an issue getting the token, continue method execution as normal
                optedOut = hasOptedOut(token, {
                    persistenceType: persistenceType,
                    persistencePrefix: persistencePrefix
                });
            }
        } catch (err) {
            console.error('Unexpected error when checking tracking opt-out status: ' + err);
        }

        if (!optedOut) {
            return method.apply(this, arguments);
        }

        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') {
            callback(0);
        }

        return;
    };
}

/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==

/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/

var init_type; // MODULE or SNIPPET loader
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE = 0;
var INIT_SNIPPET = 1;

/*
 * Constants
 */
/** @const */var PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */var SET_QUEUE_KEY = '__mps';
/** @const */var SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */var UNSET_QUEUE_KEY = '__mpus';
/** @const */var ADD_QUEUE_KEY = '__mpa';
/** @const */var APPEND_QUEUE_KEY = '__mpap';
/** @const */var UNION_QUEUE_KEY = '__mpu';
/** @const */var SET_ACTION = '$set';
/** @const */var SET_ONCE_ACTION = '$set_once';
/** @const */var UNSET_ACTION = '$unset';
/** @const */var ADD_ACTION = '$add';
/** @const */var APPEND_ACTION = '$append';
/** @const */var UNION_ACTION = '$union';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */var ALIAS_ID_KEY = '__alias';
/** @const */var CAMPAIGN_IDS_KEY = '__cmpns';
/** @const */var EVENT_TIMERS_KEY = '__timers';
/** @const */var RESERVED_PROPERTIES = [SET_QUEUE_KEY, SET_ONCE_QUEUE_KEY, UNSET_QUEUE_KEY, ADD_QUEUE_KEY, APPEND_QUEUE_KEY, UNION_QUEUE_KEY, PEOPLE_DISTINCT_ID_KEY, ALIAS_ID_KEY, CAMPAIGN_IDS_KEY, EVENT_TIMERS_KEY];

/*
 * Dynamic... constants? Is that an oxymoron?
 */
// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();

// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('Mozilla') === -1;

/*
 * Module-level globals
 */
var DEFAULT_CONFIG = {
    'api_host': 'https://api.mixpanel.com',
    'app_host': 'https://mixpanel.com',
    'autotrack': true,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_subdomain_cookie': true,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_name': '',
    'loaded': function loaded() {},
    'store_google': true,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'track_pageview': true,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {} // { header: value, header2: value }
};

var DOM_LOADED = false;

/**
 * DomTracker Object
 * @constructor
 */
var DomTracker = function DomTracker() {};

// interface
DomTracker.prototype.create_properties = function () {};
DomTracker.prototype.event_handler = function () {};
DomTracker.prototype.after_track_handler = function () {};

DomTracker.prototype.init = function (mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};

/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function(...[*])=} user_callback
 */
DomTracker.prototype.track = function (query, event_name, properties, user_callback) {
    var that = this;
    var elements = _.dom_query(query);

    if (elements.length === 0) {
        console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }

    _.each(elements, function (element) {
        _.register_event(element, this.override_event, function (e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');

            that.event_handler(e, this, options);

            // in case the mixpanel servers don't get back to us in time
            window$1.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);

    return true;
};

/**
 * @param {function(...[*])} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */
DomTracker.prototype.track_callback = function (user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;

    return function () {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) {
            return;
        }
        options.callback_fired = true;

        if (user_callback && user_callback(timeout_occured, props) === false) {
            // user can prevent the default functionality by
            // returning false from their callback
            return;
        }

        that.after_track_handler(props, options, timeout_occured);
    };
};

DomTracker.prototype.create_properties = function (properties, element) {
    var props;

    if (typeof properties === 'function') {
        props = properties(element);
    } else {
        props = _.extend({}, properties);
    }

    return props;
};

/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */
var LinkTracker = function LinkTracker() {
    this.override_event = 'click';
};
_.inherit(LinkTracker, DomTracker);

LinkTracker.prototype.create_properties = function (properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) {
        props['url'] = element.href;
    }

    return props;
};

LinkTracker.prototype.event_handler = function (evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;

    if (!options.new_tab) {
        evt.preventDefault();
    }
};

LinkTracker.prototype.after_track_handler = function (props, options) {
    if (options.new_tab) {
        return;
    }

    setTimeout(function () {
        window$1.location = options.href;
    }, 0);
};

/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */
var FormTracker = function FormTracker() {
    this.override_event = 'submit';
};
_.inherit(FormTracker, DomTracker);

FormTracker.prototype.event_handler = function (evt, element, options) {
    options.element = element;
    evt.preventDefault();
};

FormTracker.prototype.after_track_handler = function (props, options) {
    setTimeout(function () {
        options.element.submit();
    }, 0);
};

/**
 * Mixpanel Persistence Object
 * @constructor
 */
var MixpanelPersistence = function MixpanelPersistence(config) {
    this['props'] = {};
    this.campaign_params_saved = false;

    if (config['persistence_name']) {
        this.name = 'mp_' + config['persistence_name'];
    } else {
        this.name = 'mp_' + config['token'] + '_mixpanel';
    }

    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }

    if (storage_type === 'localStorage' && _.localStorage.is_supported()) {
        this.storage = _.localStorage;
    } else {
        this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};

MixpanelPersistence.prototype.properties = function () {
    var p = {};
    // Filter out reserved properties
    _.each(this['props'], function (v, k) {
        if (!_.include(RESERVED_PROPERTIES, k)) {
            p[k] = v;
        }
    });
    return p;
};

MixpanelPersistence.prototype.load = function () {
    if (this.disabled) {
        return;
    }

    var entry = this.storage.parse(this.name);

    if (entry) {
        this['props'] = _.extend({}, entry);
    }
};

MixpanelPersistence.prototype.upgrade = function (config) {
    var upgrade_from_old_lib = config['upgrade'],
        old_cookie_name,
        old_cookie;

    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === 'string') {
            old_cookie_name = upgrade_from_old_lib;
        }

        old_cookie = this.storage.parse(old_cookie_name);

        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        if (old_cookie) {
            this['props'] = _.extend(this['props'], old_cookie['all'], old_cookie['events']);
        }
    }

    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);

        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);

            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }

    if (this.storage === _.localStorage) {
        old_cookie = _.cookie.parse(this.name);

        _.cookie.remove(this.name);
        _.cookie.remove(this.name, true);

        if (old_cookie) {
            this.register_once(old_cookie);
        }
    }
};

MixpanelPersistence.prototype.save = function () {
    if (this.disabled) {
        return;
    }
    this._expire_notification_campaigns();
    this.storage.set(this.name, _.JSONEncode(this['props']), this.expire_days, this.cross_subdomain, this.secure);
};

MixpanelPersistence.prototype.remove = function () {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false);
    this.storage.remove(this.name, true);
};

// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function () {
    this.remove();
    this['props'] = {};
};

/**
 * @param {Object} props
 * @param {*=} default_value
 * @param {number=} days
 */
MixpanelPersistence.prototype.register_once = function (props, default_value, days) {
    if (_.isObject(props)) {
        if (typeof default_value === 'undefined') {
            default_value = 'None';
        }
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

        _.each(props, function (val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
                this['props'][prop] = val;
            }
        }, this);

        this.save();

        return true;
    }
    return false;
};

/**
 * @param {Object} props
 * @param {number=} days
 */
MixpanelPersistence.prototype.register = function (props, days) {
    if (_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;

        _.extend(this['props'], props);

        this.save();

        return true;
    }
    return false;
};

MixpanelPersistence.prototype.unregister = function (prop) {
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};

MixpanelPersistence.prototype._expire_notification_campaigns = _.safewrap(function () {
    var campaigns_shown = this['props'][CAMPAIGN_IDS_KEY],
        EXPIRY_TIME = Config.DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (Config.DEBUG) / 1 hour (PDXN)
    if (!campaigns_shown) {
        return;
    }
    for (var campaign_id in campaigns_shown) {
        if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
            delete campaigns_shown[campaign_id];
        }
    }
    if (_.isEmptyObject(campaigns_shown)) {
        delete this['props'][CAMPAIGN_IDS_KEY];
    }
});

MixpanelPersistence.prototype.update_campaign_params = function () {
    if (!this.campaign_params_saved) {
        this.register_once(_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};

MixpanelPersistence.prototype.update_search_keyword = function (referrer) {
    this.register(_.info.searchInfo(referrer));
};

// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function (referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
    }, '');
};

MixpanelPersistence.prototype.get_referrer_info = function () {
    return _.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};

// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
MixpanelPersistence.prototype.safe_merge = function (props) {
    _.each(this['props'], function (val, prop) {
        if (!(prop in props)) {
            props[prop] = val;
        }
    });

    return props;
};

MixpanelPersistence.prototype.update_config = function (config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};

MixpanelPersistence.prototype.set_disabled = function (disabled) {
    this.disabled = disabled;
    if (this.disabled) {
        this.remove();
    } else {
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_subdomain = function (cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.get_cross_subdomain = function () {
    return this.cross_subdomain;
};

MixpanelPersistence.prototype.set_secure = function (secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype._add_to_people_queue = function (queue, data) {
    var q_key = this._get_queue_key(queue),
        q_data = data[queue],
        set_q = this._get_or_create_queue(SET_ACTION),
        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
        unset_q = this._get_or_create_queue(UNSET_ACTION),
        add_q = this._get_or_create_queue(ADD_ACTION),
        union_q = this._get_or_create_queue(UNION_ACTION),
        append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        _.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue(ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue(UNION_ACTION, q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        _.each(q_data, function (v, k) {
            if (!(k in set_once_q)) {
                set_once_q[k] = v;
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNSET_QUEUE_KEY) {
        _.each(q_data, function (prop) {

            // undo previously-queued actions on this key
            _.each([set_q, set_once_q, add_q, union_q], function (enqueued_obj) {
                if (prop in enqueued_obj) {
                    delete enqueued_obj[prop];
                }
            });
            _.each(append_q, function (append_obj) {
                if (prop in append_obj) {
                    delete append_obj[prop];
                }
            });

            unset_q[prop] = true;
        });
    } else if (q_key === ADD_QUEUE_KEY) {
        _.each(q_data, function (v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) {
                set_q[k] += v;
            } else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) {
                    add_q[k] = 0;
                }
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        _.each(q_data, function (v, k) {
            if (_.isArray(v)) {
                if (!(k in union_q)) {
                    union_q[k] = [];
                }
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    }

    console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console$1.log(data);

    this.save();
};

MixpanelPersistence.prototype._pop_from_people_queue = function (queue, data) {
    var q = this._get_queue(queue);
    if (!_.isUndefined(q)) {
        _.each(data, function (v, k) {
            delete q[k];
        }, this);

        this.save();
    }
};

MixpanelPersistence.prototype._get_queue_key = function (queue) {
    if (queue === SET_ACTION) {
        return SET_QUEUE_KEY;
    } else if (queue === SET_ONCE_ACTION) {
        return SET_ONCE_QUEUE_KEY;
    } else if (queue === UNSET_ACTION) {
        return UNSET_QUEUE_KEY;
    } else if (queue === ADD_ACTION) {
        return ADD_QUEUE_KEY;
    } else if (queue === APPEND_ACTION) {
        return APPEND_QUEUE_KEY;
    } else if (queue === UNION_ACTION) {
        return UNION_QUEUE_KEY;
    } else {
        console$1.error('Invalid queue:', queue);
    }
};

MixpanelPersistence.prototype._get_queue = function (queue) {
    return this['props'][this._get_queue_key(queue)];
};
MixpanelPersistence.prototype._get_or_create_queue = function (queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;

    return this['props'][key] || (this['props'][key] = default_val);
};

MixpanelPersistence.prototype.set_event_timer = function (event_name, timestamp) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};

MixpanelPersistence.prototype.remove_event_timer = function (event_name) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

/**
 * Mixpanel Library Object
 * @constructor
 */
var MixpanelLib = function MixpanelLib() {};

/**
 * Mixpanel People Object
 * @constructor
 */
var MixpanelPeople = function MixpanelPeople() {};

var MPNotif;

/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */
var create_mplib = function create_mplib(token, config, name) {
    var instance,
        target = name === PRIMARY_INSTANCE_NAME ? mixpanel_master : mixpanel_master[name];

    if (target && init_type === INIT_MODULE) {
        instance = target;
    } else {
        if (target && !_.isArray(target)) {
            console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }

    instance._init(token, config, name);

    instance['people'] = new MixpanelPeople();
    instance['people']._init(instance);

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

    instance['__autotrack_enabled'] = instance.get_config('autotrack');
    if (instance.get_config('autotrack')) {
        var num_buckets = 100;
        var num_enabled_buckets = 100;
        if (!autotrack.enabledForProject(instance.get_config('token'), num_buckets, num_enabled_buckets)) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Not in active bucket: disabling Automatic Event Collection.');
        } else if (!autotrack.isBrowserSupported()) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Disabling Automatic Event Collection because this browser is not supported');
        } else {
            autotrack.init(instance);
        }
    }

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }

    return instance;
};

// Initialization methods

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */
MixpanelLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
        console$1.error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        console$1.error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }

    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();

    return instance;
};

// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function (token, config, name) {
    this['__loaded'] = true;
    this['config'] = {};

    this.set_config(_.extend({}, DEFAULT_CONFIG, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === PRIMARY_INSTANCE_NAME ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));

    this['_jsc'] = function () {};

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };

    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
    this._init_gdpr_persistence();

    this.register_once({ 'distinct_id': _.UUID() }, '');
};

// Private methods

MixpanelLib.prototype._update_persistence = function () {
    var disablePersistence = this.get_config('disable_persistence') || this.has_opted_out_tracking();
    if (this['persistence'].disabled !== disablePersistence) {
        this['persistence'].set_disabled(disablePersistence);
    }
};

MixpanelLib.prototype._loaded = function () {
    this.get_config('loaded')(this);

    // this happens after so a user can call identify/name_tag in
    // the loaded callback
    if (this.get_config('track_pageview')) {
        this.track_pageview();
    }
};

MixpanelLib.prototype._dom_loaded = function () {
    _.each(this.__dom_loaded_queue, function (item) {
        this._track_dom.apply(this, item);
    }, this);

    if (!this.has_opted_out_tracking()) {
        _.each(this.__request_queue, function (item) {
            this._send_request.apply(this, item);
        }, this);
    }

    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};

MixpanelLib.prototype._track_dom = function (DomClass, args) {
    if (this.get_config('img')) {
        console$1.error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }

    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
    }

    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};

/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */
MixpanelLib.prototype._prepare_callback = function (callback, data) {
    if (_.isUndefined(callback)) {
        return null;
    }

    if (USE_XHR) {
        var callback_function = function callback_function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function (response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};

MixpanelLib.prototype._send_request = function (url, data, callback) {
    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return;
    }

    // needed to correctly format responses
    var verbose_mode = this.get_config('verbose');
    if (data['verbose']) {
        verbose_mode = true;
    }

    if (this.get_config('test')) {
        data['test'] = 1;
    }
    if (verbose_mode) {
        data['verbose'] = 1;
    }
    if (this.get_config('img')) {
        data['img'] = 1;
    }
    if (!USE_XHR) {
        if (callback) {
            data['callback'] = callback;
        } else if (verbose_mode || this.get_config('test')) {
            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
            // which by itself is not valid javascript. Without a callback, this verbose output will
            // cause an error when returned via jsonp, so we force a no-op callback param.
            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
            data['callback'] = '(function(){})';
        }
    }

    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    url += '?' + _.HTTPBuildQuery(data);

    if ('img' in data) {
        var img = document$1.createElement('img');
        img.src = url;
        document$1.body.appendChild(img);
    } else if (USE_XHR) {
        try {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);

            var headers = this.get_config('xhr_headers');
            _.each(headers, function (headerValue, headerName) {
                req.setRequestHeader(headerName, headerValue);
            });

            // send the mp_optout cookie
            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
            req.withCredentials = true;
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    // XMLHttpRequest.DONE == 4, except in safari 4
                    if (req.status === 200) {
                        if (callback) {
                            if (verbose_mode) {
                                var response;
                                try {
                                    response = _.JSONDecode(req.responseText);
                                } catch (e) {
                                    console$1.error(e);
                                    return;
                                }
                                callback(response);
                            } else {
                                callback(Number(req.responseText));
                            }
                        }
                    } else {
                        var error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                        console$1.error(error);
                        if (callback) {
                            if (verbose_mode) {
                                callback({ status: 0, error: error });
                            } else {
                                callback(0);
                            }
                        }
                    }
                }
            };
            req.send(null);
        } catch (e) {
            console$1.error(e);
        }
    } else {
        var script = document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
};

/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */
MixpanelLib.prototype._execute_array = function (array) {
    var fn_name,
        alias_calls = [],
        other_calls = [],
        tracking_calls = [];
    _.each(array, function (item) {
        if (item) {
            fn_name = item[0];
            if (typeof item === 'function') {
                item.call(this);
            } else if (_.isArray(item) && fn_name === 'alias') {
                alias_calls.push(item);
            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') {
                tracking_calls.push(item);
            } else {
                other_calls.push(item);
            }
        }
    }, this);

    var execute = function execute(calls, context) {
        _.each(calls, function (item) {
            this[item[0]].apply(this, item.slice(1));
        }, context);
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};

/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */
MixpanelLib.prototype.push = function (item) {
    this._execute_array([item]);
};

/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */
MixpanelLib.prototype.disable = function (events) {
    if (typeof events === 'undefined') {
        this._flags.disable_all_events = true;
    } else {
        this.__disabled_events = this.__disabled_events.concat(events);
    }
};

/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */
MixpanelLib.prototype.track = addOptOutCheckMixpanelLib(function (event_name, properties, callback) {
    if (typeof callback !== 'function') {
        callback = function callback() {};
    }

    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.track');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }

    // set defaults
    properties = properties || {};
    properties['token'] = this.get_config('token');

    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    // update persistence
    this['persistence'].update_search_keyword(document$1.referrer);

    if (this.get_config('store_google')) {
        this['persistence'].update_campaign_params();
    }
    if (this.get_config('save_referrer')) {
        this['persistence'].update_referrer_info(document$1.referrer);
    }

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend({}, _.info.properties(), this['persistence'].properties(), properties);

    var property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
        _.each(property_blacklist, function (blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
    } else {
        console$1.error('Invalid value for property_blacklist config: ' + property_blacklist);
    }

    var data = {
        'event': event_name,
        'properties': properties
    };

    var truncated_data = _.truncate(data, 255);
    var json_data = _.JSONEncode(truncated_data);
    var encoded_data = _.base64Encode(json_data);

    console$1.log('MIXPANEL REQUEST:');
    console$1.log(truncated_data);

    this._send_request(this.get_config('api_host') + '/track/', { 'data': encoded_data }, this._prepare_callback(callback, truncated_data));

    return truncated_data;
});

/**
 * Track a page view event, which is currently ignored by the server.
 * This function is called by default on page load unless the
 * track_pageview configuration variable is false.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @api private
 */
MixpanelLib.prototype.track_pageview = function (page) {
    if (_.isUndefined(page)) {
        page = document$1.location.href;
    }
    this.track('mp_page_view', _.info.pageviewInfo(page));
};

/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */
MixpanelLib.prototype.track_links = function () {
    return this._track_dom.call(this, LinkTracker, arguments);
};

/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */
MixpanelLib.prototype.track_forms = function () {
    return this._track_dom.call(this, FormTracker, arguments);
};

/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */
MixpanelLib.prototype.time_event = function (event_name) {
    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.time_event');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        return;
    }

    this['persistence'].set_event_timer(event_name, new Date().getTime());
};

/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number} [days] How many days since the user's last visit to store the super properties
 */
MixpanelLib.prototype.register = function (props, days) {
    this['persistence'].register(props, days);
};

/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number} [days] How many days since the users last visit to store the super properties
 */
MixpanelLib.prototype.register_once = function (props, default_value, days) {
    this['persistence'].register_once(props, default_value, days);
};

/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 */
MixpanelLib.prototype.unregister = function (property) {
    this['persistence'].unregister(property);
};

MixpanelLib.prototype._register_single = function (prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};

/**
 * Identify a user with a unique ID instead of a Mixpanel
 * randomly generated distinct_id. If the method is never called,
 * then unique visitors will be identified by a UUID generated
 * the first time they visit the site.
 *
 * ### Notes:
 *
 * You can call this function to overwrite a previously set
 * unique ID for the current user. Mixpanel cannot translate
 * between IDs at this time, so when you change a user's ID
 * they will appear to be a new user.
 *
 * When used alone, mixpanel.identify will change the user's
 * distinct_id to the unique ID provided. When used in tandem
 * with mixpanel.alias, it will allow you to identify based on
 * unique ID and map that back to the original, anonymous
 * distinct_id given to the user upon her first arrival to your
 * site (thus connecting anonymous pre-signup activity to
 * post-signup activity). Though the two work together, do not
 * call identify() at the same time as alias(). Calling the two
 * at the same time can cause a race condition, so it is best
 * practice to call identify on the original, anonymous ID
 * right after you've aliased it.
 * <a href="https://mixpanel.com/help/questions/articles/how-should-i-handle-my-user-identity-with-the-mixpanel-javascript-library">Learn more about how mixpanel.identify and mixpanel.alias can be used</a>.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */
MixpanelLib.prototype.identify = function (unique_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (unique_id !== this.get_distinct_id() && unique_id !== this.get_property(ALIAS_ID_KEY)) {
        this.unregister(ALIAS_ID_KEY);
        this._register_single('distinct_id', unique_id);
    }
    this._check_and_handle_notifications(this.get_distinct_id());
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback);
};

/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */
MixpanelLib.prototype.reset = function () {
    this['persistence'].clear();
    this._flags.identify_called = false;
    this.register_once({ 'distinct_id': _.UUID() }, '');
};

/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */
MixpanelLib.prototype.get_distinct_id = function () {
    return this.get_property('distinct_id');
};

/**
 * Create an alias, which Mixpanel will use to link two distinct_ids going forward (not retroactively).
 * Multiple aliases can map to the same original ID, but not vice-versa. Aliases can also be chained - the
 * following is a valid scenario:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     ...
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * If the original ID is not passed in, we will use the current distinct_id - probably the auto-generated GUID.
 *
 * ### Notes:
 *
 * The best practice is to call alias() when a unique ID is first created for a user
 * (e.g., when a user first registers for an account and provides an email address).
 * alias() should never be called more than once for a given user, except to
 * chain a newer ID to a previously new ID, as described above.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */
MixpanelLib.prototype.alias = function (alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
        console$1.critical('Attempting to create alias for existing People user - aborting.');
        return -2;
    }

    var _this = this;
    if (_.isUndefined(original)) {
        original = this.get_distinct_id();
    }
    if (alias !== original) {
        this._register_single(ALIAS_ID_KEY, alias);
        return this.track('$create_alias', { 'alias': alias, 'distinct_id': original }, function () {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        console$1.error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};

/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @api private
 */
MixpanelLib.prototype.name_tag = function (name_tag) {
    this._register_single('mp_name_tag', name_tag);
};

/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // should we track a page view on page load
 *       track_pageview: true
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */
MixpanelLib.prototype.set_config = function (config) {
    if (_.isObject(config)) {
        _.extend(this['config'], config);

        if (!this.get_config('persistence_name')) {
            this['config']['persistence_name'] = this['config']['cookie_name'];
        }
        if (!this.get_config('disable_persistence')) {
            this['config']['disable_persistence'] = this['config']['disable_cookie'];
        }

        if (this['persistence']) {
            this['persistence'].update_config(this['config']);
        }
        Config.DEBUG = Config.DEBUG || this.get_config('debug');
    }
};

/**
 * returns the current config object for the library.
 */
MixpanelLib.prototype.get_config = function (prop_name) {
    return this['config'][prop_name];
};

/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */
MixpanelLib.prototype.get_property = function (property_name) {
    return this['persistence']['props'][property_name];
};

MixpanelLib.prototype.toString = function () {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + '.' + name;
    }
    return name;
};

MixpanelLib.prototype._event_is_disabled = function (event_name) {
    return _.isBlockedUA(userAgent) || this._flags.disable_all_events || _.include(this.__disabled_events, event_name);
};

MixpanelLib.prototype._check_and_handle_notifications = addOptOutCheckMixpanelLib(function (distinct_id) {
    if (!distinct_id || this._flags.identify_called || this.get_config('disable_notifications')) {
        return;
    }

    console$1.log('MIXPANEL NOTIFICATION CHECK');

    var data = {
        'verbose': true,
        'version': '2',
        'lib': 'web',
        'token': this.get_config('token'),
        'distinct_id': distinct_id
    };
    var self = this;
    this._send_request(this.get_config('api_host') + '/decide/', data, this._prepare_callback(function (r) {
        if (r['notifications'] && r['notifications'].length > 0) {
            self._show_notification.call(self, r['notifications'][0]);
        }
    }));
});

MixpanelLib.prototype._show_notification = function (notification_data) {
    var notification = new MPNotif(notification_data, this);
    notification.show();
};

// perform some housekeeping around GDPR persistence of opt-in/out state
MixpanelLib.prototype._init_gdpr_persistence = function () {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';

    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && _.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ 'persistence_type': 'cookie' })) {
            this.opt_in_tracking();
        }
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({ 'persistence_type': 'cookie' })) {
            this.opt_out_tracking();
        }
        this.clear_opt_in_out_tracking({ 'persistence_type': 'cookie' });
    }

    // check whether we should opt out by default and update persistence accordingly
    if (this.get_config('opt_out_tracking_by_default') || _.cookie.get('mp_optout')) {
        _.cookie.remove('mp_optout');
        this.opt_out_tracking();
    }
    this._update_persistence();
};

// call a base gdpr function after constructing the appropriate token and options args
MixpanelLib.prototype._call_gdpr_func = function (func, options) {
    options = _.extend({
        'track': _.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'secure_cookie': this.get_config('secure_cookie')
    }, options);

    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!_.localStorage.is_supported()) {
        options['persistence_type'] = 'cookie';
    }

    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieExpiration: options['cookie_expiration'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie']
    });
};

/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_in_tracking = function (options) {
    this._call_gdpr_func(optIn, options);
    this._update_persistence();
};

/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_out_tracking = function (options) {
    // delete use and clear charges since these methods may be disabled by opt-out
    options = _.extend({ 'delete_user': true }, options);
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }

    this._call_gdpr_func(optOut, options);
    this._update_persistence();
};

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */
MixpanelLib.prototype.has_opted_in_tracking = function (options) {
    return this._call_gdpr_func(hasOptedIn, options);
};

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */
MixpanelLib.prototype.has_opted_out_tracking = function (options) {
    return this._call_gdpr_func(hasOptedOut, options);
};

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.clear_opt_in_out_tracking = function (options) {
    this._call_gdpr_func(clearOptInOut, options);
    this._update_persistence();
};

MixpanelPeople.prototype._init = function (mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};

/*
 * Set properties on a user record.
 *
 * ### Usage:
 *
 *     mixpanel.people.set('gender', 'm');
 *
 *     // or set multiple properties at once
 *     mixpanel.people.set({
 *         'Company': 'Acme',
 *         'Plan': 'Premium',
 *         'Upgrade date': new Date()
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.set = addOptOutCheckMixpanelPeople(function (prop, to, callback) {
    var data = {};
    var $set = {};
    if (_.isObject(prop)) {
        _.each(prop, function (v, k) {
            if (!this._is_reserved_property(k)) {
                $set[k] = v;
            }
        }, this);
        callback = to;
    } else {
        $set[prop] = to;
    }

    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) {
        this._mixpanel['persistence'].update_referrer_info(document$1.referrer);
    }

    // update $set object with default people properties
    $set = _.extend({}, _.info.people_properties(), this._mixpanel['persistence'].get_referrer_info(), $set);

    data[SET_ACTION] = $set;

    return this._send_request(data, callback);
});

/*
 * Set properties on a user record, only if they do not yet exist.
 * This will not overwrite previous people property values, unlike
 * people.set().
 *
 * ### Usage:
 *
 *     mixpanel.people.set_once('First Login Date', new Date());
 *
 *     // or set multiple properties at once
 *     mixpanel.people.set_once({
 *         'First Login Date': new Date(),
 *         'Starting Plan': 'Premium'
 *     });
 *
 *     // properties can be strings, integers or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.set_once = addOptOutCheckMixpanelPeople(function (prop, to, callback) {
    var data = {};
    var $set_once = {};
    if (_.isObject(prop)) {
        _.each(prop, function (v, k) {
            if (!this._is_reserved_property(k)) {
                $set_once[k] = v;
            }
        }, this);
        callback = to;
    } else {
        $set_once[prop] = to;
    }
    data[SET_ONCE_ACTION] = $set_once;
    return this._send_request(data, callback);
});

/*
 * Unset properties on a user record (permanently removes the properties and their values from a profile).
 *
 * ### Usage:
 *
 *     mixpanel.people.unset('gender');
 *
 *     // or unset multiple properties at once
 *     mixpanel.people.unset(['gender', 'Company']);
 *
 * @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.unset = function (prop, callback) {
    var data = {};
    var $unset = [];
    if (!_.isArray(prop)) {
        prop = [prop];
    }

    _.each(prop, function (k) {
        if (!this._is_reserved_property(k)) {
            $unset.push(k);
        }
    }, this);

    data[UNSET_ACTION] = $unset;

    return this._send_request(data, callback);
};

/*
 * Increment/decrement numeric people analytics properties.
 *
 * ### Usage:
 *
 *     mixpanel.people.increment('page_views', 1);
 *
 *     // or, for convenience, if you're just incrementing a counter by
 *     // 1, you can simply do
 *     mixpanel.people.increment('page_views');
 *
 *     // to decrement a counter, pass a negative number
 *     mixpanel.people.increment('credits_left', -1);
 *
 *     // like mixpanel.people.set(), you can increment multiple
 *     // properties at once:
 *     mixpanel.people.increment({
 *         counter1: 1,
 *         counter2: 6
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
 * @param {Number} [by] An amount to increment the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.increment = addOptOutCheckMixpanelPeople(function (prop, by, callback) {
    var data = {};
    var $add = {};
    if (_.isObject(prop)) {
        _.each(prop, function (v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else {
                    $add[k] = v;
                }
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if (_.isUndefined(by)) {
            by = 1;
        }
        $add[prop] = by;
    }
    data[ADD_ACTION] = $add;

    return this._send_request(data, callback);
});

/*
 * Append a value to a list-valued people analytics property.
 *
 * ### Usage:
 *
 *     // append a value to a list, creating it if needed
 *     mixpanel.people.append('pages_visited', 'homepage');
 *
 *     // like mixpanel.people.set(), you can append multiple
 *     // properties at once:
 *     mixpanel.people.append({
 *         list1: 'bob',
 *         list2: 123
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [value] An item to append to the list
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.append = addOptOutCheckMixpanelPeople(function (list_name, value, callback) {
    var data = {};
    var $append = {};
    if (_.isObject(list_name)) {
        _.each(list_name, function (v, k) {
            if (!this._is_reserved_property(k)) {
                $append[k] = v;
            }
        }, this);
        callback = value;
    } else {
        $append[list_name] = value;
    }
    data[APPEND_ACTION] = $append;

    return this._send_request(data, callback);
});

/*
 * Merge a given list with a list-valued people analytics property,
 * excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.people.union('pages_visited', 'homepage');
 *
 *     // like mixpanel.people.set(), you can append multiple
 *     // properties at once:
 *     mixpanel.people.union({
 *         list1: 'bob',
 *         list2: 123
 *     });
 *
 *     // like mixpanel.people.append(), you can append multiple
 *     // values to the same list:
 *     mixpanel.people.union({
 *         list1: ['bob', 'billy']
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [value] Value / values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.union = addOptOutCheckMixpanelPeople(function (list_name, values, callback) {
    var data = {};
    var $union = {};
    if (_.isObject(list_name)) {
        _.each(list_name, function (v, k) {
            if (!this._is_reserved_property(k)) {
                $union[k] = _.isArray(v) ? v : [v];
            }
        }, this);
        callback = values;
    } else {
        $union[list_name] = _.isArray(values) ? values : [values];
    }
    data[UNION_ACTION] = $union;

    return this._send_request(data, callback);
});

/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 */
MixpanelPeople.prototype.track_charge = addOptOutCheckMixpanelPeople(function (amount, properties, callback) {
    if (!_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }

    return this.append('$transactions', _.extend({
        '$amount': amount
    }, properties), callback);
});

/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.clear_charges = function (callback) {
    return this.set('$transactions', [], callback);
};

/*
 * Permanently deletes the current people analytics profile from
 * Mixpanel (using the current distinct_id).
 *
 * ### Usage:
 *
 *     // remove the all data you have stored about the current user
 *     mixpanel.people.delete_user();
 *
 */
MixpanelPeople.prototype.delete_user = function () {
    if (!this._identify_called()) {
        console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = { '$delete': this._mixpanel.get_distinct_id() };
    return this._send_request(data);
};

MixpanelPeople.prototype.toString = function () {
    return this._mixpanel.toString() + '.people';
};

MixpanelPeople.prototype._send_request = function (data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();

    var date_encoded_data = _.encodeDates(data);
    var truncated_data = _.truncate(date_encoded_data, 255);
    var json_data = _.JSONEncode(date_encoded_data);
    var encoded_data = _.base64Encode(json_data);

    if (!this._identify_called()) {
        this._enqueue(data);
        if (!_.isUndefined(callback)) {
            if (this._get_config('verbose')) {
                callback({ status: -1, error: null });
            } else {
                callback(-1);
            }
        }
        return truncated_data;
    }

    console$1.log('MIXPANEL PEOPLE REQUEST:');
    console$1.log(truncated_data);

    this._mixpanel._send_request(this._get_config('api_host') + '/engage/', { 'data': encoded_data }, this._mixpanel._prepare_callback(callback, truncated_data));

    return truncated_data;
};

MixpanelPeople.prototype._get_config = function (conf_var) {
    return this._mixpanel.get_config(conf_var);
};

MixpanelPeople.prototype._identify_called = function () {
    return this._mixpanel._flags.identify_called === true;
};

// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function (data) {
    if (SET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
    } else if (SET_ONCE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
    } else if (UNSET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
    } else if (ADD_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
    } else if (APPEND_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
    } else if (UNION_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
    } else {
        console$1.error('Invalid call to _enqueue():', data);
    }
};

MixpanelPeople.prototype._flush_one_queue = function (action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = _.extend({}, this._mixpanel['persistence']._get_queue(action));
    var action_params = queued_data;

    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) {
            action_params = queue_to_params_fn(queued_data);
        }
        action_method.call(_this, action_params, function (response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            }
            if (!_.isUndefined(callback)) {
                callback(response, data);
            }
        });
    }
};

// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function (_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback) {
    var _this = this;
    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);

    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function (queue) {
        return _.keys(queue);
    });
    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);

    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var callback = function callback(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
            }
            if (!_.isUndefined(_append_callback)) {
                _append_callback(response, data);
            }
        };
        for (var i = $append_queue.length - 1; i >= 0; i--) {
            $append_item = $append_queue.pop();
            _this.append($append_item, callback);
        }
        // Save the shortened append queue
        _this._mixpanel['persistence'].save();
    }
};

MixpanelPeople.prototype._is_reserved_property = function (prop) {
    return prop === '$distinct_id' || prop === '$token';
};

// Internal class for notification display
MixpanelLib._Notification = function (notif_data, mixpanel_instance) {
    _.bind_instance_methods(this);

    this.mixpanel = mixpanel_instance;
    this.persistence = this.mixpanel['persistence'];

    this.campaign_id = _.escapeHTML(notif_data['id']);
    this.message_id = _.escapeHTML(notif_data['message_id']);

    this.body = (_.escapeHTML(notif_data['body']) || '').replace(/\n/g, '<br/>');
    this.cta = _.escapeHTML(notif_data['cta']) || 'Close';
    this.notif_type = _.escapeHTML(notif_data['type']) || 'takeover';
    this.style = _.escapeHTML(notif_data['style']) || 'light';
    this.title = _.escapeHTML(notif_data['title']) || '';
    this.video_width = MPNotif.VIDEO_WIDTH;
    this.video_height = MPNotif.VIDEO_HEIGHT;

    // These fields are url-sanitized in the backend already.
    this.dest_url = notif_data['cta_url'] || null;
    this.image_url = notif_data['image_url'] || null;
    this.thumb_image_url = notif_data['thumb_image_url'] || null;
    this.video_url = notif_data['video_url'] || null;

    this.clickthrough = true;
    if (!this.dest_url) {
        this.dest_url = '#dismiss';
        this.clickthrough = false;
    }

    this.mini = this.notif_type === 'mini';
    if (!this.mini) {
        this.notif_type = 'takeover';
    }
    this.notif_width = !this.mini ? MPNotif.NOTIF_WIDTH : MPNotif.NOTIF_WIDTH_MINI;

    this._set_client_config();
    this.imgs_to_preload = this._init_image_html();
    this._init_video();
};

MPNotif = MixpanelLib._Notification;

MPNotif.ANIM_TIME = 200;
MPNotif.MARKUP_PREFIX = 'mixpanel-notification';
MPNotif.BG_OPACITY = 0.6;
MPNotif.NOTIF_TOP = 25;
MPNotif.NOTIF_START_TOP = 200;
MPNotif.NOTIF_WIDTH = 388;
MPNotif.NOTIF_WIDTH_MINI = 420;
MPNotif.NOTIF_HEIGHT_MINI = 85;
MPNotif.THUMB_BORDER_SIZE = 5;
MPNotif.THUMB_IMG_SIZE = 60;
MPNotif.THUMB_OFFSET = Math.round(MPNotif.THUMB_IMG_SIZE / 2);
MPNotif.VIDEO_WIDTH = 595;
MPNotif.VIDEO_HEIGHT = 334;

MPNotif.prototype.show = function () {
    var self = this;
    this._set_client_config();

    // don't display until HTML body exists
    if (!this.body_el) {
        setTimeout(function () {
            self.show();
        }, 300);
        return;
    }

    this._init_styles();
    this._init_notification_el();

    // wait for any images to load before showing notification
    this._preload_images(this._attach_and_animate);
};

MPNotif.prototype.dismiss = _.safewrap(function () {
    if (!this.marked_as_shown) {
        // unexpected condition: user interacted with notif even though we didn't consider it
        // visible (see _mark_as_shown()); send tracking signals to mark delivery
        this._mark_delivery({ 'invisible': true });
    }

    var exiting_el = this.showing_video ? this._get_el('video') : this._get_notification_display_el();
    if (this.use_transitions) {
        this._remove_class('bg', 'visible');
        this._add_class(exiting_el, 'exiting');
        setTimeout(this._remove_notification_el, MPNotif.ANIM_TIME);
    } else {
        var notif_attr, notif_start, notif_goal;
        if (this.mini) {
            notif_attr = 'right';
            notif_start = 20;
            notif_goal = -100;
        } else {
            notif_attr = 'top';
            notif_start = MPNotif.NOTIF_TOP;
            notif_goal = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
        }
        this._animate_els([{
            el: this._get_el('bg'),
            attr: 'opacity',
            start: MPNotif.BG_OPACITY,
            goal: 0.0
        }, {
            el: exiting_el,
            attr: 'opacity',
            start: 1.0,
            goal: 0.0
        }, {
            el: exiting_el,
            attr: notif_attr,
            start: notif_start,
            goal: notif_goal
        }], MPNotif.ANIM_TIME, this._remove_notification_el);
    }
});

MPNotif.prototype._add_class = _.safewrap(function (el, class_name) {
    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (!el.className) {
        el.className = class_name;
    } else if (!~(' ' + el.className + ' ').indexOf(' ' + class_name + ' ')) {
        el.className += ' ' + class_name;
    }
});
MPNotif.prototype._remove_class = _.safewrap(function (el, class_name) {
    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (el.className) {
        el.className = (' ' + el.className + ' ').replace(' ' + class_name + ' ', '').replace(/^[\s\xA0]+/, '').replace(/[\s\xA0]+$/, '');
    }
});

MPNotif.prototype._animate_els = _.safewrap(function (anims, mss, done_cb, start_time) {
    var self = this,
        in_progress = false,
        ai,
        anim,
        cur_time = 1 * new Date(),
        time_diff;

    start_time = start_time || cur_time;
    time_diff = cur_time - start_time;

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (typeof anim.val === 'undefined') {
            anim.val = anim.start;
        }
        if (anim.val !== anim.goal) {
            in_progress = true;
            var anim_diff = anim.goal - anim.start,
                anim_dir = anim.goal >= anim.start ? 1 : -1;
            anim.val = anim.start + anim_diff * time_diff / mss;
            if (anim.attr !== 'opacity') {
                anim.val = Math.round(anim.val);
            }
            if (anim_dir > 0 && anim.val >= anim.goal || anim_dir < 0 && anim.val <= anim.goal) {
                anim.val = anim.goal;
            }
        }
    }
    if (!in_progress) {
        if (done_cb) {
            done_cb();
        }
        return;
    }

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (anim.el) {
            var suffix = anim.attr === 'opacity' ? '' : 'px';
            anim.el.style[anim.attr] = String(anim.val) + suffix;
        }
    }
    setTimeout(function () {
        self._animate_els(anims, mss, done_cb, start_time);
    }, 10);
});

MPNotif.prototype._attach_and_animate = _.safewrap(function () {
    var self = this;

    // no possibility to double-display
    if (this.shown || this._get_shown_campaigns()[this.campaign_id]) {
        return;
    }
    this.shown = true;

    this.body_el.appendChild(this.notification_el);
    setTimeout(function () {
        var notif_el = self._get_notification_display_el();
        if (self.use_transitions) {
            if (!self.mini) {
                self._add_class('bg', 'visible');
            }
            self._add_class(notif_el, 'visible');
            self._mark_as_shown();
        } else {
            var notif_attr, notif_start, notif_goal;
            if (self.mini) {
                notif_attr = 'right';
                notif_start = -100;
                notif_goal = 20;
            } else {
                notif_attr = 'top';
                notif_start = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
                notif_goal = MPNotif.NOTIF_TOP;
            }
            self._animate_els([{
                el: self._get_el('bg'),
                attr: 'opacity',
                start: 0.0,
                goal: MPNotif.BG_OPACITY
            }, {
                el: notif_el,
                attr: 'opacity',
                start: 0.0,
                goal: 1.0
            }, {
                el: notif_el,
                attr: notif_attr,
                start: notif_start,
                goal: notif_goal
            }], MPNotif.ANIM_TIME, self._mark_as_shown);
        }
    }, 100);
    _.register_event(self._get_el('cancel'), 'click', function (e) {
        e.preventDefault();
        self.dismiss();
    });
    var click_el = self._get_el('button') || self._get_el('mini-content');
    _.register_event(click_el, 'click', function (e) {
        e.preventDefault();
        if (self.show_video) {
            self._track_event('$campaign_open', { '$resource_type': 'video' });
            self._switch_to_video();
        } else {
            self.dismiss();
            if (self.clickthrough) {
                self._track_event('$campaign_open', { '$resource_type': 'link' }, function () {
                    window$1.location.href = self.dest_url;
                });
            }
        }
    });
});

MPNotif.prototype._get_el = function (id) {
    return document$1.getElementById(MPNotif.MARKUP_PREFIX + '-' + id);
};

MPNotif.prototype._get_notification_display_el = function () {
    return this._get_el(this.notif_type);
};

MPNotif.prototype._get_shown_campaigns = function () {
    return this.persistence['props'][CAMPAIGN_IDS_KEY] || (this.persistence['props'][CAMPAIGN_IDS_KEY] = {});
};

MPNotif.prototype._browser_lte = function (browser, version) {
    return this.browser_versions[browser] && this.browser_versions[browser] <= version;
};

MPNotif.prototype._init_image_html = function () {
    var imgs_to_preload = [];

    if (!this.mini) {
        if (this.image_url) {
            imgs_to_preload.push(this.image_url);
            this.img_html = '<img id="img" src="' + this.image_url + '"/>';
        } else {
            this.img_html = '';
        }
        if (this.thumb_image_url) {
            imgs_to_preload.push(this.thumb_image_url);
            this.thumb_img_html = '<div id="thumbborder-wrapper"><div id="thumbborder"></div></div>' + '<img id="thumbnail"' + ' src="' + this.thumb_image_url + '"' + ' width="' + MPNotif.THUMB_IMG_SIZE + '"' + ' height="' + MPNotif.THUMB_IMG_SIZE + '"' + '/>' + '<div id="thumbspacer"></div>';
        } else {
            this.thumb_img_html = '';
        }
    } else {
        this.thumb_image_url = this.thumb_image_url || '//cdn.mxpnl.com/site_media/images/icons/notifications/mini-news-dark.png';
        imgs_to_preload.push(this.thumb_image_url);
    }

    return imgs_to_preload;
};

MPNotif.prototype._init_notification_el = function () {
    var notification_html = '';
    var video_src = '';
    var video_html = '';
    var cancel_html = '<div id="cancel">' + '<div id="cancel-icon"></div>' + '</div>';

    this.notification_el = document$1.createElement('div');
    this.notification_el.id = MPNotif.MARKUP_PREFIX + '-wrapper';
    if (!this.mini) {
        // TAKEOVER notification
        var close_html = this.clickthrough || this.show_video ? '' : '<div id="button-close"></div>',
            play_html = this.show_video ? '<div id="button-play"></div>' : '';
        if (this._browser_lte('ie', 7)) {
            close_html = '';
            play_html = '';
        }
        notification_html = '<div id="takeover">' + this.thumb_img_html + '<div id="mainbox">' + cancel_html + '<div id="content">' + this.img_html + '<div id="title">' + this.title + '</div>' + '<div id="body">' + this.body + '</div>' + '<div id="tagline">' + '<a href="http://mixpanel.com?from=inapp" target="_blank">POWERED BY MIXPANEL</a>' + '</div>' + '</div>' + '<div id="button">' + close_html + '<a id="button-link" href="' + this.dest_url + '">' + this.cta + '</a>' + play_html + '</div>' + '</div>' + '</div>';
    } else {
        // MINI notification
        notification_html = '<div id="mini">' + '<div id="mainbox">' + cancel_html + '<div id="mini-content">' + '<div id="mini-icon">' + '<div id="mini-icon-img"></div>' + '</div>' + '<div id="body">' + '<div id="body-text"><div>' + this.body + '</div></div>' + '</div>' + '</div>' + '</div>' + '<div id="mini-border"></div>' + '</div>';
    }
    if (this.youtube_video) {
        video_src = '//www.youtube.com/embed/' + this.youtube_video + '?wmode=transparent&showinfo=0&modestbranding=0&rel=0&autoplay=1&loop=0&vq=hd1080';
        if (this.yt_custom) {
            video_src += '&enablejsapi=1&html5=1&controls=0';
            video_html = '<div id="video-controls">' + '<div id="video-progress" class="video-progress-el">' + '<div id="video-progress-total" class="video-progress-el"></div>' + '<div id="video-elapsed" class="video-progress-el"></div>' + '</div>' + '<div id="video-time" class="video-progress-el"></div>' + '</div>';
        }
    } else if (this.vimeo_video) {
        video_src = '//player.vimeo.com/video/' + this.vimeo_video + '?autoplay=1&title=0&byline=0&portrait=0';
    }
    if (this.show_video) {
        this.video_iframe = '<iframe id="' + MPNotif.MARKUP_PREFIX + '-video-frame" ' + 'width="' + this.video_width + '" height="' + this.video_height + '" ' + ' src="' + video_src + '"' + ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen="1" scrolling="no"' + '></iframe>';
        video_html = '<div id="video-' + (this.flip_animate ? '' : 'no') + 'flip">' + '<div id="video">' + '<div id="video-holder"></div>' + video_html + '</div>' + '</div>';
    }
    var main_html = video_html + notification_html;
    if (this.flip_animate) {
        main_html = (this.mini ? notification_html : '') + '<div id="flipcontainer"><div id="flipper">' + (this.mini ? video_html : main_html) + '</div></div>';
    }

    this.notification_el.innerHTML = ('<div id="overlay" class="' + this.notif_type + '">' + '<div id="campaignid-' + this.campaign_id + '">' + '<div id="bgwrapper">' + '<div id="bg"></div>' + main_html + '</div>' + '</div>' + '</div>').replace(/class=\"/g, 'class="' + MPNotif.MARKUP_PREFIX + '-').replace(/id=\"/g, 'id="' + MPNotif.MARKUP_PREFIX + '-');
};

MPNotif.prototype._init_styles = function () {
    if (this.style === 'dark') {
        this.style_vals = {
            bg: '#1d1f25',
            bg_actions: '#282b32',
            bg_hover: '#3a4147',
            bg_light: '#4a5157',
            border_gray: '#32353c',
            cancel_opacity: '0.4',
            mini_hover: '#2a3137',
            text_title: '#fff',
            text_main: '#9498a3',
            text_tagline: '#464851',
            text_hover: '#ddd'
        };
    } else {
        this.style_vals = {
            bg: '#fff',
            bg_actions: '#e7eaee',
            bg_hover: '#eceff3',
            bg_light: '#f5f5f5',
            border_gray: '#e4ecf2',
            cancel_opacity: '1.0',
            mini_hover: '#fafafa',
            text_title: '#5c6578',
            text_main: '#8b949b',
            text_tagline: '#ced9e6',
            text_hover: '#7c8598'
        };
    }
    var shadow = '0px 0px 35px 0px rgba(45, 49, 56, 0.7)',
        video_shadow = shadow,
        mini_shadow = shadow,
        thumb_total_size = MPNotif.THUMB_IMG_SIZE + MPNotif.THUMB_BORDER_SIZE * 2,
        anim_seconds = MPNotif.ANIM_TIME / 1000 + 's';
    if (this.mini) {
        shadow = 'none';
    }

    // don't display on small viewports
    var notif_media_queries = {},
        min_width = MPNotif.NOTIF_WIDTH_MINI + 20;
    notif_media_queries['@media only screen and (max-width: ' + (min_width - 1) + 'px)'] = {
        '#overlay': {
            'display': 'none'
        }
    };
    var notif_styles = {
        '.flipped': {
            'transform': 'rotateY(180deg)'
        },
        '#overlay': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'overflow': 'auto',
            'text-align': 'center',
            'z-index': '10000',
            'font-family': '"Helvetica", "Arial", sans-serif',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale'
        },
        '#overlay.mini': {
            'height': '0',
            'overflow': 'visible'
        },
        '#overlay a': {
            'width': 'initial',
            'padding': '0',
            'text-decoration': 'none',
            'text-transform': 'none',
            'color': 'inherit'
        },
        '#bgwrapper': {
            'position': 'relative',
            'width': '100%',
            'height': '100%'
        },
        '#bg': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'min-width': this.doc_width * 4 + 'px',
            'min-height': this.doc_height * 4 + 'px',
            'background-color': 'black',
            'opacity': '0.0',
            '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)', // IE8
            'filter': 'alpha(opacity=60)', // IE5-7
            'transition': 'opacity ' + anim_seconds
        },
        '#bg.visible': {
            'opacity': MPNotif.BG_OPACITY
        },
        '.mini #bg': {
            'width': '0',
            'height': '0',
            'min-width': '0'
        },
        '#flipcontainer': {
            'perspective': '1000px',
            'position': 'absolute',
            'width': '100%'
        },
        '#flipper': {
            'position': 'relative',
            'transform-style': 'preserve-3d',
            'transition': '0.3s'
        },
        '#takeover': {
            'position': 'absolute',
            'left': '50%',
            'width': MPNotif.NOTIF_WIDTH + 'px',
            'margin-left': Math.round(-MPNotif.NOTIF_WIDTH / 2) + 'px',
            'backface-visibility': 'hidden',
            'transform': 'rotateY(0deg)',
            'opacity': '0.0',
            'top': MPNotif.NOTIF_START_TOP + 'px',
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#takeover.visible': {
            'opacity': '1.0',
            'top': MPNotif.NOTIF_TOP + 'px'
        },
        '#takeover.exiting': {
            'opacity': '0.0',
            'top': MPNotif.NOTIF_START_TOP + 'px'
        },
        '#thumbspacer': {
            'height': MPNotif.THUMB_OFFSET + 'px'
        },
        '#thumbborder-wrapper': {
            'position': 'absolute',
            'top': -MPNotif.THUMB_BORDER_SIZE + 'px',
            'left': MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET - MPNotif.THUMB_BORDER_SIZE + 'px',
            'width': thumb_total_size + 'px',
            'height': thumb_total_size / 2 + 'px',
            'overflow': 'hidden'
        },
        '#thumbborder': {
            'position': 'absolute',
            'width': thumb_total_size + 'px',
            'height': thumb_total_size + 'px',
            'border-radius': thumb_total_size + 'px',
            'background-color': this.style_vals.bg_actions,
            'opacity': '0.5'
        },
        '#thumbnail': {
            'position': 'absolute',
            'top': '0px',
            'left': MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET + 'px',
            'width': MPNotif.THUMB_IMG_SIZE + 'px',
            'height': MPNotif.THUMB_IMG_SIZE + 'px',
            'overflow': 'hidden',
            'z-index': '100',
            'border-radius': MPNotif.THUMB_IMG_SIZE + 'px'
        },
        '#mini': {
            'position': 'absolute',
            'right': '20px',
            'top': MPNotif.NOTIF_TOP + 'px',
            'width': this.notif_width + 'px',
            'height': MPNotif.NOTIF_HEIGHT_MINI * 2 + 'px',
            'margin-top': 20 - MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'backface-visibility': 'hidden',
            'opacity': '0.0',
            'transform': 'rotateX(90deg)',
            'transition': 'opacity 0.3s, transform 0.3s, right 0.3s'
        },
        '#mini.visible': {
            'opacity': '1.0',
            'transform': 'rotateX(0deg)'
        },
        '#mini.exiting': {
            'opacity': '0.0',
            'right': '-150px'
        },
        '#mainbox': {
            'border-radius': '4px',
            'box-shadow': shadow,
            'text-align': 'center',
            'background-color': this.style_vals.bg,
            'font-size': '14px',
            'color': this.style_vals.text_main
        },
        '#mini #mainbox': {
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini-border': {
            'height': MPNotif.NOTIF_HEIGHT_MINI + 6 + 'px',
            'width': MPNotif.NOTIF_WIDTH_MINI + 6 + 'px',
            'position': 'absolute',
            'top': '-3px',
            'left': '-3px',
            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '6px',
            'opacity': '0.25',
            'background-color': '#fff',
            'z-index': '-1',
            'box-shadow': mini_shadow
        },
        '#mini-icon': {
            'position': 'relative',
            'display': 'inline-block',
            'width': '75px',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px 0 0 3px',
            'background-color': this.style_vals.bg_actions,
            'background': 'linear-gradient(135deg, ' + this.style_vals.bg_light + ' 0%, ' + this.style_vals.bg_actions + ' 100%)',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini:hover #mini-icon': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini:hover #mainbox': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini-icon-img': {
            'position': 'absolute',
            'background-image': 'url(' + this.thumb_image_url + ')',
            'width': '48px',
            'height': '48px',
            'top': '20px',
            'left': '12px'
        },
        '#content': {
            'padding': '30px 20px 0px 20px'
        },
        '#mini-content': {
            'text-align': 'left',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'cursor': 'pointer'
        },
        '#img': {
            'width': '328px',
            'margin-top': '30px',
            'border-radius': '5px'
        },
        '#title': {
            'max-height': '600px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'padding': '25px 0px 20px 0px',
            'font-size': '19px',
            'font-weight': 'bold',
            'color': this.style_vals.text_title
        },
        '#body': {
            'max-height': '600px',
            'margin-bottom': '25px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'line-height': '21px',
            'font-size': '15px',
            'font-weight': 'normal',
            'text-align': 'left'
        },
        '#mini #body': {
            'display': 'inline-block',
            'max-width': '250px',
            'margin': '0 0 0 30px',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'font-size': '16px',
            'letter-spacing': '0.8px',
            'color': this.style_vals.text_title
        },
        '#mini #body-text': {
            'display': 'table',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px'
        },
        '#mini #body-text div': {
            'display': 'table-cell',
            'vertical-align': 'middle'
        },
        '#tagline': {
            'margin-bottom': '15px',
            'font-size': '10px',
            'font-weight': '600',
            'letter-spacing': '0.8px',
            'color': '#ccd7e0',
            'text-align': 'left'
        },
        '#tagline a': {
            'color': this.style_vals.text_tagline,
            'transition': 'color ' + anim_seconds
        },
        '#tagline a:hover': {
            'color': this.style_vals.text_hover
        },
        '#cancel': {
            'position': 'absolute',
            'right': '0',
            'width': '8px',
            'height': '8px',
            'padding': '10px',
            'border-radius': '20px',
            'margin': '12px 12px 0 0',
            'box-sizing': 'content-box',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini #cancel': {
            'margin': '7px 7px 0 0'
        },
        '#cancel-icon': {
            'width': '8px',
            'height': '8px',
            'overflow': 'hidden',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/cancel-x.png)',
            'opacity': this.style_vals.cancel_opacity
        },
        '#cancel:hover': {
            'background-color': this.style_vals.bg_hover
        },
        '#button': {
            'display': 'block',
            'height': '60px',
            'line-height': '60px',
            'text-align': 'center',
            'background-color': this.style_vals.bg_actions,
            'border-radius': '0 0 4px 4px',
            'overflow': 'hidden',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#button-close': {
            'display': 'inline-block',
            'width': '9px',
            'height': '60px',
            'margin-right': '8px',
            'vertical-align': 'top',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/close-x-' + this.style + '.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 25px'
        },
        '#button-play': {
            'display': 'inline-block',
            'width': '30px',
            'height': '60px',
            'margin-left': '15px',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/play-' + this.style + '-small.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 15px'
        },
        'a#button-link': {
            'display': 'inline-block',
            'vertical-align': 'top',
            'text-align': 'center',
            'font-size': '17px',
            'font-weight': 'bold',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'color': this.style_vals.text_title,
            'transition': 'color ' + anim_seconds
        },
        '#button:hover': {
            'background-color': this.style_vals.bg_hover,
            'color': this.style_vals.text_hover
        },
        '#button:hover a': {
            'color': this.style_vals.text_hover
        },

        '#video-noflip': {
            'position': 'relative',
            'top': -this.video_height * 2 + 'px'
        },
        '#video-flip': {
            'backface-visibility': 'hidden',
            'transform': 'rotateY(180deg)'
        },
        '#video': {
            'position': 'absolute',
            'width': this.video_width - 1 + 'px',
            'height': this.video_height + 'px',
            'top': MPNotif.NOTIF_TOP + 'px',
            'margin-top': '100px',
            'left': '50%',
            'margin-left': Math.round(-this.video_width / 2) + 'px',
            'overflow': 'hidden',
            'border-radius': '5px',
            'box-shadow': video_shadow,
            'transform': 'translateZ(1px)', // webkit rendering bug http://stackoverflow.com/questions/18167981/clickable-link-area-unexpectedly-smaller-after-css-transform
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#video.exiting': {
            'opacity': '0.0',
            'top': this.video_height + 'px'
        },
        '#video-holder': {
            'position': 'absolute',
            'width': this.video_width - 1 + 'px',
            'height': this.video_height + 'px',
            'overflow': 'hidden',
            'border-radius': '5px'
        },
        '#video-frame': {
            'margin-left': '-1px',
            'width': this.video_width + 'px'
        },
        '#video-controls': {
            'opacity': '0',
            'transition': 'opacity 0.5s'
        },
        '#video:hover #video-controls': {
            'opacity': '1.0'
        },
        '#video .video-progress-el': {
            'position': 'absolute',
            'bottom': '0',
            'height': '25px',
            'border-radius': '0 0 0 5px'
        },
        '#video-progress': {
            'width': '90%'
        },
        '#video-progress-total': {
            'width': '100%',
            'background-color': this.style_vals.bg,
            'opacity': '0.7'
        },
        '#video-elapsed': {
            'width': '0',
            'background-color': '#6cb6f5',
            'opacity': '0.9'
        },
        '#video #video-time': {
            'width': '10%',
            'right': '0',
            'font-size': '11px',
            'line-height': '25px',
            'color': this.style_vals.text_main,
            'background-color': '#666',
            'border-radius': '0 0 5px 0'
        }
    };

    // IE hacks
    if (this._browser_lte('ie', 8)) {
        _.extend(notif_styles, {
            '* html #overlay': {
                'position': 'absolute'
            },
            '* html #bg': {
                'position': 'absolute'
            },
            'html, body': {
                'height': '100%'
            }
        });
    }
    if (this._browser_lte('ie', 7)) {
        _.extend(notif_styles, {
            '#mini #body': {
                'display': 'inline',
                'zoom': '1',
                'border': '1px solid ' + this.style_vals.bg_hover
            },
            '#mini #body-text': {
                'padding': '20px'
            },
            '#mini #mini-icon': {
                'display': 'none'
            }
        });
    }

    // add vendor-prefixed style rules
    var VENDOR_STYLES = ['backface-visibility', 'border-radius', 'box-shadow', 'opacity', 'perspective', 'transform', 'transform-style', 'transition'],
        VENDOR_PREFIXES = ['khtml', 'moz', 'ms', 'o', 'webkit'];
    for (var selector in notif_styles) {
        for (var si = 0; si < VENDOR_STYLES.length; si++) {
            var prop = VENDOR_STYLES[si];
            if (prop in notif_styles[selector]) {
                var val = notif_styles[selector][prop];
                for (var pi = 0; pi < VENDOR_PREFIXES.length; pi++) {
                    notif_styles[selector]['-' + VENDOR_PREFIXES[pi] + '-' + prop] = val;
                }
            }
        }
    }

    var inject_styles = function inject_styles(styles, media_queries) {
        var create_style_text = function create_style_text(style_defs) {
            var st = '';
            for (var selector in style_defs) {
                var mp_selector = selector.replace(/#/g, '#' + MPNotif.MARKUP_PREFIX + '-').replace(/\./g, '.' + MPNotif.MARKUP_PREFIX + '-');
                st += '\n' + mp_selector + ' {';
                var props = style_defs[selector];
                for (var k in props) {
                    st += k + ':' + props[k] + ';';
                }
                st += '}';
            }
            return st;
        };
        var create_media_query_text = function create_media_query_text(mq_defs) {
            var mqt = '';
            for (var mq in mq_defs) {
                mqt += '\n' + mq + ' {' + create_style_text(mq_defs[mq]) + '\n}';
            }
            return mqt;
        };

        var style_text = create_style_text(styles) + create_media_query_text(media_queries),
            head_el = document$1.head || document$1.getElementsByTagName('head')[0] || document$1.documentElement,
            style_el = document$1.createElement('style');
        head_el.appendChild(style_el);
        style_el.setAttribute('type', 'text/css');
        if (style_el.styleSheet) {
            // IE
            style_el.styleSheet.cssText = style_text;
        } else {
            style_el.textContent = style_text;
        }
    };
    inject_styles(notif_styles, notif_media_queries);
};

MPNotif.prototype._init_video = _.safewrap(function () {
    if (!this.video_url) {
        return;
    }
    var self = this;

    // Youtube iframe API compatibility
    self.yt_custom = 'postMessage' in window$1;

    self.dest_url = self.video_url;
    var youtube_match = self.video_url.match(
    // http://stackoverflow.com/questions/2936467/parse-youtube-video-id-using-preg-match
    /(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i),
        vimeo_match = self.video_url.match(/vimeo\.com\/.*?(\d+)/i);
    if (youtube_match) {
        self.show_video = true;
        self.youtube_video = youtube_match[1];

        if (self.yt_custom) {
            window$1['onYouTubeIframeAPIReady'] = function () {
                if (self._get_el('video-frame')) {
                    self._yt_video_ready();
                }
            };

            // load Youtube iframe API; see https://developers.google.com/youtube/iframe_api_reference
            var tag = document$1.createElement('script');
            tag.src = '//www.youtube.com/iframe_api';
            var firstScriptTag = document$1.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    } else if (vimeo_match) {
        self.show_video = true;
        self.vimeo_video = vimeo_match[1];
    }

    // IE <= 7, FF <= 3: fall through to video link rather than embedded player
    if (self._browser_lte('ie', 7) || self._browser_lte('firefox', 3)) {
        self.show_video = false;
        self.clickthrough = true;
    }
});

MPNotif.prototype._mark_as_shown = _.safewrap(function () {
    // click on background to dismiss
    var self = this;
    _.register_event(self._get_el('bg'), 'click', function () {
        self.dismiss();
    });

    var get_style = function get_style(el, style_name) {
        var styles = {};
        if (document$1.defaultView && document$1.defaultView.getComputedStyle) {
            styles = document$1.defaultView.getComputedStyle(el, null); // FF3 requires both args
        } else if (el.currentStyle) {
            // IE
            styles = el.currentStyle;
        }
        return styles[style_name];
    };

    if (this.campaign_id) {
        var notif_el = this._get_el('overlay');
        if (notif_el && get_style(notif_el, 'visibility') !== 'hidden' && get_style(notif_el, 'display') !== 'none') {
            this._mark_delivery();
        }
    }
});

MPNotif.prototype._mark_delivery = _.safewrap(function (extra_props) {
    if (!this.marked_as_shown) {
        this.marked_as_shown = true;

        if (this.campaign_id) {
            // mark notification shown (local cache)
            this._get_shown_campaigns()[this.campaign_id] = 1 * new Date();
            this.persistence.save();
        }

        // track delivery
        this._track_event('$campaign_delivery', extra_props);

        // mark notification shown (mixpanel property)
        this.mixpanel['people']['append']({
            '$campaigns': this.campaign_id,
            '$notifications': {
                'campaign_id': this.campaign_id,
                'message_id': this.message_id,
                'type': 'web',
                'time': new Date()
            }
        });
    }
});

MPNotif.prototype._preload_images = function (all_loaded_cb) {
    var self = this;
    if (this.imgs_to_preload.length === 0) {
        all_loaded_cb();
        return;
    }

    var preloaded_imgs = 0;
    var img_objs = [];
    var onload = function onload() {
        preloaded_imgs++;
        if (preloaded_imgs === self.imgs_to_preload.length && all_loaded_cb) {
            all_loaded_cb();
            all_loaded_cb = null;
        }
    };
    for (var i = 0; i < this.imgs_to_preload.length; i++) {
        var img = new Image();
        img.onload = onload;
        img.src = this.imgs_to_preload[i];
        if (img.complete) {
            onload();
        }
        img_objs.push(img);
    }

    // IE6/7 doesn't fire onload reliably
    if (this._browser_lte('ie', 7)) {
        setTimeout(function () {
            var imgs_loaded = true;
            for (i = 0; i < img_objs.length; i++) {
                if (!img_objs[i].complete) {
                    imgs_loaded = false;
                }
            }
            if (imgs_loaded && all_loaded_cb) {
                all_loaded_cb();
                all_loaded_cb = null;
            }
        }, 500);
    }
};

MPNotif.prototype._remove_notification_el = _.safewrap(function () {
    window$1.clearInterval(this._video_progress_checker);
    this.notification_el.style.visibility = 'hidden';
    this.body_el.removeChild(this.notification_el);
});

MPNotif.prototype._set_client_config = function () {
    var get_browser_version = function get_browser_version(browser_ex) {
        var match = navigator.userAgent.match(browser_ex);
        return match && match[1];
    };
    this.browser_versions = {};
    this.browser_versions['chrome'] = get_browser_version(/Chrome\/(\d+)/);
    this.browser_versions['firefox'] = get_browser_version(/Firefox\/(\d+)/);
    this.browser_versions['ie'] = get_browser_version(/MSIE (\d+).+/);
    if (!this.browser_versions['ie'] && !window$1.ActiveXObject && 'ActiveXObject' in window$1) {
        this.browser_versions['ie'] = 11;
    }

    this.body_el = document$1.body || document$1.getElementsByTagName('body')[0];
    if (this.body_el) {
        this.doc_width = Math.max(this.body_el.scrollWidth, document$1.documentElement.scrollWidth, this.body_el.offsetWidth, document$1.documentElement.offsetWidth, this.body_el.clientWidth, document$1.documentElement.clientWidth);
        this.doc_height = Math.max(this.body_el.scrollHeight, document$1.documentElement.scrollHeight, this.body_el.offsetHeight, document$1.documentElement.offsetHeight, this.body_el.clientHeight, document$1.documentElement.clientHeight);
    }

    // detect CSS compatibility
    var ie_ver = this.browser_versions['ie'];
    var sample_styles = document$1.createElement('div').style,
        is_css_compatible = function is_css_compatible(rule) {
        if (rule in sample_styles) {
            return true;
        }
        if (!ie_ver) {
            rule = rule[0].toUpperCase() + rule.slice(1);
            var props = ['O' + rule, 'Webkit' + rule, 'Moz' + rule];
            for (var i = 0; i < props.length; i++) {
                if (props[i] in sample_styles) {
                    return true;
                }
            }
        }
        return false;
    };
    this.use_transitions = this.body_el && is_css_compatible('transition') && is_css_compatible('transform');
    this.flip_animate = (this.browser_versions['chrome'] >= 33 || this.browser_versions['firefox'] >= 15) && this.body_el && is_css_compatible('backfaceVisibility') && is_css_compatible('perspective') && is_css_compatible('transform');
};

MPNotif.prototype._switch_to_video = _.safewrap(function () {
    var self = this,
        anims = [{
        el: self._get_notification_display_el(),
        attr: 'opacity',
        start: 1.0,
        goal: 0.0
    }, {
        el: self._get_notification_display_el(),
        attr: 'top',
        start: MPNotif.NOTIF_TOP,
        goal: -500
    }, {
        el: self._get_el('video-noflip'),
        attr: 'opacity',
        start: 0.0,
        goal: 1.0
    }, {
        el: self._get_el('video-noflip'),
        attr: 'top',
        start: -self.video_height * 2,
        goal: 0
    }];

    if (self.mini) {
        var bg = self._get_el('bg'),
            overlay = self._get_el('overlay');
        bg.style.width = '100%';
        bg.style.height = '100%';
        overlay.style.width = '100%';

        self._add_class(self._get_notification_display_el(), 'exiting');
        self._add_class(bg, 'visible');

        anims.push({
            el: self._get_el('bg'),
            attr: 'opacity',
            start: 0.0,
            goal: MPNotif.BG_OPACITY
        });
    }

    var video_el = self._get_el('video-holder');
    video_el.innerHTML = self.video_iframe;

    var video_ready = function video_ready() {
        if (window$1['YT'] && window$1['YT']['loaded']) {
            self._yt_video_ready();
        }
        self.showing_video = true;
        self._get_notification_display_el().style.visibility = 'hidden';
    };
    if (self.flip_animate) {
        self._add_class('flipper', 'flipped');
        setTimeout(video_ready, MPNotif.ANIM_TIME);
    } else {
        self._animate_els(anims, MPNotif.ANIM_TIME, video_ready);
    }
});

MPNotif.prototype._track_event = function (event_name, properties, cb) {
    if (this.campaign_id) {
        properties = properties || {};
        properties = _.extend(properties, {
            'campaign_id': this.campaign_id,
            'message_id': this.message_id,
            'message_type': 'web_inapp',
            'message_subtype': this.notif_type
        });
        this.mixpanel['track'](event_name, properties, cb);
    } else if (cb) {
        cb.call();
    }
};

MPNotif.prototype._yt_video_ready = _.safewrap(function () {
    var self = this;
    if (self.video_inited) {
        return;
    }
    self.video_inited = true;

    var progress_bar = self._get_el('video-elapsed'),
        progress_time = self._get_el('video-time'),
        progress_el = self._get_el('video-progress');

    new window$1['YT']['Player'](MPNotif.MARKUP_PREFIX + '-video-frame', {
        'events': {
            'onReady': function onReady(event) {
                var ytplayer = event['target'],
                    video_duration = ytplayer['getDuration'](),
                    pad = function pad(i) {
                    return ('00' + i).slice(-2);
                },
                    update_video_time = function update_video_time(current_time) {
                    var secs = Math.round(video_duration - current_time),
                        mins = Math.floor(secs / 60),
                        hours = Math.floor(mins / 60);
                    secs -= mins * 60;
                    mins -= hours * 60;
                    progress_time.innerHTML = '-' + (hours ? hours + ':' : '') + pad(mins) + ':' + pad(secs);
                };
                update_video_time(0);
                self._video_progress_checker = window$1.setInterval(function () {
                    var current_time = ytplayer['getCurrentTime']();
                    progress_bar.style.width = current_time / video_duration * 100 + '%';
                    update_video_time(current_time);
                }, 250);
                _.register_event(progress_el, 'click', function (e) {
                    var clickx = Math.max(0, e.pageX - progress_el.getBoundingClientRect().left);
                    ytplayer['seekTo'](video_duration * clickx / progress_el.clientWidth, true);
                });
            }
        }
    });
});

// EXPORTS (for closure compiler)

// MixpanelLib Exports
MixpanelLib.prototype['init'] = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset'] = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable'] = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event'] = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track'] = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links'] = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms'] = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview'] = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register'] = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once'] = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister'] = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify'] = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias'] = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag'] = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config'] = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config'] = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property'] = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id'] = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString'] = MixpanelLib.prototype.toString;
MixpanelLib.prototype['_check_and_handle_notifications'] = MixpanelLib.prototype._check_and_handle_notifications;
MixpanelLib.prototype['_show_notification'] = MixpanelLib.prototype._show_notification;
MixpanelLib.prototype['opt_out_tracking'] = MixpanelLib.prototype.opt_out_tracking;
MixpanelLib.prototype['opt_in_tracking'] = MixpanelLib.prototype.opt_in_tracking;
MixpanelLib.prototype['has_opted_out_tracking'] = MixpanelLib.prototype.has_opted_out_tracking;
MixpanelLib.prototype['has_opted_in_tracking'] = MixpanelLib.prototype.has_opted_in_tracking;
MixpanelLib.prototype['clear_opt_in_out_tracking'] = MixpanelLib.prototype.clear_opt_in_out_tracking;

// MixpanelPersistence Exports
MixpanelPersistence.prototype['properties'] = MixpanelPersistence.prototype.properties;
MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
MixpanelPersistence.prototype['update_referrer_info'] = MixpanelPersistence.prototype.update_referrer_info;
MixpanelPersistence.prototype['get_cross_subdomain'] = MixpanelPersistence.prototype.get_cross_subdomain;
MixpanelPersistence.prototype['clear'] = MixpanelPersistence.prototype.clear;

// MixpanelPeople Exports
MixpanelPeople.prototype['set'] = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once'] = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset'] = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment'] = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append'] = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['union'] = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge'] = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user'] = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString'] = MixpanelPeople.prototype.toString;

_.safewrap_class(MixpanelLib, ['identify', '_check_and_handle_notifications', '_show_notification']);

var instances = {};
var extend_mp = function extend_mp() {
    // add all the sub mixpanel instances
    _.each(instances, function (instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) {
            mixpanel_master[name] = instance;
        }
    });

    // add private functions as _
    mixpanel_master['_'] = _;
};

var override_mp_init_func = function override_mp_init_func() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function (token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;

            if (instances[PRIMARY_INSTANCE_NAME]) {
                // main mixpanel lib already initialized
                instance = instances[PRIMARY_INSTANCE_NAME];
            } else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }

            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) {
                window$1[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            }
            extend_mp();
        }
    };
};

var add_dom_loaded_handler = function add_dom_loaded_handler() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) {
            return;
        }
        dom_loaded_handler.done = true;

        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;

        _.each(instances, function (inst) {
            inst._dom_loaded();
        });
    }

    function do_scroll_check() {
        try {
            document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }

        dom_loaded_handler();
    }

    if (document$1.addEventListener) {
        if (document$1.readyState === 'complete') {
            // safari 4 can fire the DOMContentLoaded event before loading all
            // external JS (including this file). you will see some copypasta
            // on the internet that checks for 'complete' and 'loaded', but
            // 'loaded' is an IE thing
            dom_loaded_handler();
        } else {
            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
        }
    } else if (document$1.attachEvent) {
        // IE
        document$1.attachEvent('onreadystatechange', dom_loaded_handler);

        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = window$1.frameElement === null;
        } catch (e) {
            // noop
        }

        if (document$1.documentElement.doScroll && toplevel) {
            do_scroll_check();
        }
    }

    // fallback handler, always will work
    _.register_event(window$1, 'load', dom_loaded_handler, true);
};

function init_as_module() {
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();

    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();

    return mixpanel_master;
}

var mixpanel = init_as_module();

module.exports = mixpanel;

/***/ }),

/***/ "bnN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("szLA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("W4AX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);




var sizeToHeadingLevel = {
  'xs': 5,
  'sm': 4,
  'md': 3,
  'lg': 2,
  'xl': 1
};

var Heading = function Heading(_ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'md' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'dark' : _ref$color,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === undefined ? 'normal' : _ref$fontWeight,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === undefined ? 'left' : _ref$textAlign,
      id = _ref.id,
      accessibilityLevel = _ref.accessibilityLevel;

  var classes = [__WEBPACK_IMPORTED_MODULE_2__style___default.a.heading, __WEBPACK_IMPORTED_MODULE_2__style___default.a[size], __WEBPACK_IMPORTED_MODULE_1__style___default.a[color], __WEBPACK_IMPORTED_MODULE_1__style___default.a[fontWeight], __WEBPACK_IMPORTED_MODULE_1__style___default.a[textAlign]];
  var headingLevel = accessibilityLevel ? accessibilityLevel : sizeToHeadingLevel[size];

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('h' + headingLevel, { 'class': classes.join(' '), id: id }, children);
};
/* harmony default export */ __webpack_exports__["a"] = (Heading);

/***/ }),

/***/ "dkkB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f11378d8cd569374ade6a8b2f25623ed.jpg";

/***/ }),

/***/ "gkyg":
/***/ (function(module, exports) {

module.exports = [{"title":"数学思维训练专题","ageGroup":"小学高年级至高中生","courses":[{"image":"preview1_1.jpg","title":"数学思维入门课","buyUrl":"http://www.ddianke.com/course/38","blocks":[{"title":"适龄学生","content":"小学高年级至高中生"},{"title":"课程简介","content":"建立良好的数学思维对于数学学习而言至关重要，所谓“工欲善其事，必先利其器”。罗博深《数学思维入门课》将带你走进生活中的趣味数学问题，由身边的细节来逐步探寻解决数学问题的思维方法。\n\n在思维课中，罗教授将会将用深入浅出的教学方式，从问题出发，带领同学通过“发现数学结构”，“关于体积”，“技术与概率”和“关于球体”这四个主题，学习几何，代数和统计等基础数学知识，并培养同学们的数学思考能力。\n\n本课程几乎不设门槛，无需有深厚的数学基础或参与奥赛的经历，只需要学生了解分数四则运算，就可以快速上手。同时，高年级和数学竞赛的同学也可以从课程中得到启发，获得更深刻和灵活的数学思考能力。"},{"title":"课程设计","content":"•\t4大主题：发现数学结构，体积，计数与概率，球体\n•\t12个课时（140分钟），10个有趣的实际生活中的案例\n•\t4节基础课，6节提高课，1节课配套练习 +1节课线上研讨"},{"title":"课程大纲","content":"任务1： 美式橄榄球\n任务2： 关于“15”的游戏\n任务3：詹姆斯邦德的马蒂尼酒\n任务4：30公里长的牛奶\n第三讲：计数与概率\n任务5：运动队的平均人数\n任务6：合作的价值\n任务7：坚持的意义\n任务8：1000英里的飞行\n任务9：纽约到悉尼的最短路线\n任务10：环绕赤道的绳子\n任务11：习题集\n任务12：直播课实录"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"詹姆斯邦德的马蒂尼酒","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/38/task/770/content/preview","previewImg":"preview1_1.jpg","previewAlt":"TODO"}]},{"image":"preview1_2.jpg","title":"数学思维高阶课","buyUrl":"http://www.ddianke.com/course/43","blocks":[{"title":"适龄学生","content":"初高中有7-12年级生，以及对数学奥林匹克，AMC等竞赛感兴趣的同学"},{"title":"课程简介","content":"我们的思维与身体一样，想要得到锻炼，就要不断挑战永攀高峰！罗博深《数学思维高阶课》将带领同学从组合数学中入手，探索如何将几何，代数，数论和概率等概念联系在一起，用创造性思维解决有难度，有挑战的数学难题。\n\n课程将从最简单也最特别的事例出发，引导学生从多个角度来探求一个问题的不同解法。这样的研究过程使得解数学题如同推倒多米诺骨牌一样轻而易举又妙趣横生。\n\n在课程中，罗教授将与同学们一起探索推导数学史上最优美的公式：欧拉公式，并介绍诸如帕斯卡三角，卢卡斯定理，容斥公式等非常有价值的数学概念的使用技巧。"},{"title":"课程设计","content":"•\t聚焦美式教学中的一个重要领域——组合问题\n•\t内容跨越几何、数论、概率、代数等多个数学领域\n•\t10个课时，共计400分钟"},{"title":"课程大纲","content":"任务1： 创意计数\n任务2： 三维空间\n任务3： 完全无序\n任务4： 计算路径\n任务5： 计算和数论\n任务6： 二项式系数\n任务7： 卡塔兰数\n任务8： 翻转硬币的概率\n任务9： 罗博深的习题集\n任务10：直播课实录"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"创意计数","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/43/task/835/content/preview","previewImg":"preview1_2.jpg","previewAlt":"TODO"}]}]},{"title":"小学专题","ageGroup":"3-7年级学生","courses":[{"image":"preview2_1.jpg","title":"小学数学思维课：魔法算数","buyUrl":"http://www.ddianke.com/course/71","blocks":[{"title":"适龄学生","content":"小学3-5年级生"},{"title":"课程简介","content":"算数作为数学领域最古老且简朴的分支之一，是学习数学的第一块敲门砖。学好算数能让同学们在未来的数学学习中受益无穷。\n\n在《魔法算数》课程中，罗教授会带领同学们探讨高斯算法，无限循环，因数分解，快速除余算法等主题。通过看似简单实则经过精心设计的练习，和同学们一起寻找算数中有创造力的解题诀窍。"},{"title":"课程设计","content":"•\t围绕提升数感来设计，将高阶数学思考方式融入计算数字、发现规律的过程\n•\t13道精心设计的代表性算术题目\n•\t13个课时（不含课程介绍），共计150分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 77x77 - 76x78 巧算相邻数乘积差\n任务3： 1+2+3+4+….+10 高斯算法新解\n任务4： (1+2+3+4)+(1+2+3+4+5)+… 奇妙的三角数连加\n任务5： 1x2+2x3+3x4+….+9x10 神奇的金字塔体积\n任务6： 1/(1x2)+1/(2x3)+1/(3x4)+1/(4x5) 望远镜求和\n任务7： 1/7 有趣的无限循环\n任务8： 0.123123123123 无限循环小数的分数变换\n任务9： 0.125 有限与无限循环小数的差别\n任务10： 1001 最美的素因数分解\n任务11： 899 = ?x? 巧妙的素因数分解\n任务12： 2312/ 9 快速除余算法一\n任务13： 2312/ 3 快速除余算法二\n任务14： 2312/ 11 快速除余算法三"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/71/task/1369/content/preview","previewImg":"preview2_1.jpg","previewAlt":"TODO"}]},{"image":"preview2_2.jpg","title":"小学数学思维课：排列组合入门","buyUrl":"http://www.ddianke.com/course/91","blocks":[{"title":"适龄学生","content":"中小学3-7年级生"},{"title":"课程简介","content":"组合数学是数学中与生活之间联系最紧密的一个分支，它的难度并不算太大，却非常有趣。我们可以在日常生活中很多地方运用到排列组合的知识：比如决定拍照片时的站位，制作菜肴时食材的搭配，甚至连童话故事里，海盗在分宝藏的时候也会运用到排列组合的知识。\n\n在《排列组合》课程中，罗教授将会带领同学们从最简单的阶乘、组合数开始，探索一系列由易到难的排列组合知识。在课程的最后章节，还会讲解范德蒙德卷积等难度较大的数学问题。\n\n在12周的课程中，同学们将会学习使用互补计数法，插板法，估算法等一系列巧妙地解决排列组合的方法。\n\n由于排列组合不会涉及到非常复杂的数学计算，没有代数基础的同学也可以尝试《排列组合》同时，由于在国内中小学课堂中涉及到排列组合的知识很少，因此这门课也十分适合3-7年级的学生学习。"},{"title":"课程设计","content":"•\t关注排列组合问题中有创造力的解题诀窍，涵盖主题：排列、组合、补集、阶乘、组合爆炸等\n•\t12道精心设计的代表性组合数学题目\n•\t12课时，时长共134分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 拍照片\n任务3： 朋友排队\n任务4： 吃饺子\n任务5： 家庭聚餐\n任务6： 大聚餐\n任务7： 做汤\n任务8： 海盗宝藏\n任务9： 递增数\n任务10： 电话号码\n任务11： 重复数字\n任务12： 慷慨的海盗"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/91/task/1665/content/preview","previewImg":"preview2_2.jpg","previewAlt":"TODO"},{"title":"拍照片","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/91/task/1855/content/preview","previewImg":"preview2_2.jpg","previewAlt":"TODO"}]},{"image":"preview2_3.jpg","title":"小学数学思维课：平面几何基础","buyUrl":"http://www.ddianke.com/course/92","blocks":[{"title":"适龄学生","content":"小学4-6年级生，具有基本平面几何知识基础"},{"title":"课程简介","content":"几何是数学中极为重要的分支，涵盖了庞大的知识点，所以内容的难度也相对跨度较大。罗教授的《平面几何》会通过讲解几何中非常重要的图形：三角形和圆形带领大家进入独特而神秘的几何王国。\n\n“当古希腊人绘制圆形和支线时，就深深为他们发现的巧合所着迷。在我看来，几何不仅是一门美丽的学科，更重要的是，它可以教会你怎样证明，怎样通过逻辑进行推理。”\n\n在《平面几何》课程中，罗教授教授会将创造性数学思维方式和建立数学知识之间的关联都融入到小学生们能够掌握的数学领域，带领同学们学习重心，勾股定理，海伦公式，皮克定理等主题。\n\n随着课程的推进，会逐步帮助学生掌握平面几何的定理和公式，理解定理和公式背后的推导过程，同时逐步建立逻辑推理和数学证明的能力。"},{"title":"课程设计","content":"•\t解题过程中避免使用代数等进阶技巧，在小学数学知识范围内进行推演\n•\t12道精心设计的代表性平面几何题目\n•\t12课时（不含课程介绍），时长共190分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 角度的和\n任务3： 多边形内角\n任务4： 半圆的三角形\n任务5： 圆周角\n任务6： 圆内接四边形\n任务7： π\n任务8： 有趣的三角形\n任务9： 移动面积\n任务10： 勾股定理\n任务11： 皮克定理\n任务12： 重合部分面积\n任务13： 重心"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/92/task/1666/content/preview","previewImg":"preview2_3.jpg","previewAlt":"TODO"},{"title":"半圆的三角形","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/92/task/1889/content/preview","previewImg":"preview2_3.jpg","previewAlt":"TODO"}]}]},{"title":"中学专题","ageGroup":"7-12年级学生","courses":[{"image":"preview3_1.jpg","title":"中学数学思维课：数论入门","buyUrl":"http://www.ddianke.com/course/73","blocks":[{"title":"适龄学生","content":"初中6-9年级生"},{"title":"课程简介","content":"数论是数学王国中非常重要的分支，罗教授的《数论入门》是首次推出的面向国内中学生的数论入门课。这门课程强调数论中隐藏的创造力，鼓励同学们养成深度思考的数学思维，让同学们探索数字与概念之间的关系，打通数学领域之间的关联地图。\n\n在《数论入门》这节课中，罗教授将带领同学们学习同余方程式，费马小定理，中国余数定理等数论中最基础，最重要的定论。通过对于这些定论伸入的学习和理解，为未来数论的学习打下坚实的基础。"},{"title":"课程设计","content":"•\t17道精心设计的代表性数论题目\n•\t17课时（不含课程介绍），时长共254分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 31415926 模101求余 巧妙速算法\n任务3： 求( 1001, 728)的最大公因数 质因数分解\n任务4： 求( 1001,1008)最大公因数 欧几里得算法\n任务5： 2x 模11求余 质数同余剩余类\n任务6： 3x 模10求余 互质同余剩余类\n任务7： 4x 模10求余 非互质同余剩余类\n任务8： 6x 模7余1 解同余方程式 1\n任务9： 4x 模105余1 解同余方程式 2\n任务10： 29x 模42余1 欧几里得算法与同余方程式\n任务11： x 模5余3；x模3余1 二同余式方程组\n任务12： x 模13余3；x 模15余7 中国剩余定理\n任务13： x 模3余2；x模5余1；x模7余5 多同余式方程组\n任务14： 鸡块定理－整数表达式\n任务15： 7的2017次方的末位数 乘方的末位数\n任务16： 4x模11的求余 剩余类的相似性\n任务17： 9的88次方模89的余数 费马小定理\n任务18： 7x7^17 模19的余数 应用费马小定理"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/73/task/1393/content/preview","previewImg":"preview3_1.jpg","previewAlt":"TODO"},{"title":"巧妙速算法","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/73/task/1394/content/preview","previewImg":"preview3_1.jpg","previewAlt":"TODO"}]},{"image":"preview3_2.jpg","title":"中学数学思维课：神奇数列","buyUrl":"http://www.ddianke.com/course/72","blocks":[{"title":"适龄学生","content":"中学6-9年级生"},{"title":"课程简介","content":"奇妙的斐波那契数列，在我们的身边无处不在，神秘的帕斯卡三角，帮我们解决了无数古今数学难题。数学的奥秘也许正源于一个个规律的不断发现。这些神奇的数列中我们能发现无数的规律，并使用它们解决实际问题。\n\n在《神奇数列》课程中，罗教授会带着学生从算数入手，探索斐波那契数列和帕斯卡三角的奥秘。通过有趣的案例发现数列中的模式，提升逻辑证明，深度思考的数学思维能力。"},{"title":"课程设计","content":"•\t15道精心设计的代表性数列题目\n•\t15课时，时长共 220分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 1/89 最美的分数（初识斐波那契数列）\n任务3： 5x5+8x8 连续斐波那契数的平方求和\n任务4： 斐波那契蜜蜂（从简单寻找规律）\n任务5： 1+1+2+3+5+8+13+21+34+55 斐波那契数列之和\n任务6： 1x1+1x1+2x2+3x3+5x5+8x8 斐波那契螺旋\n任务7： 初识帕斯卡三角\n任务8： 选择一支队伍／排列组合与帕斯卡三角\n任务9： 帕斯卡三角的神奇巧合\n任务10： 11x11x11x11 帕斯卡三角与二项式定理\n任务11： 1-6+15-20+15-6+1 排列组合中的奇偶相等\n任务12： 排列组合，斐波那契蜂巢与帕斯卡三角\n任务13： 帕斯卡三角斜线数组和与两种证明\n任务14： 帕斯卡三角的倾斜数组和与斐波那契数\n任务15： 神奇的√5\n任务16： 黄金比例长方形与斐波那契螺旋"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/72/task/1383/content/preview","previewImg":"preview3_2.jpg","previewAlt":"TODO"},{"title":"1/89 最美的分数","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/72/task/1384/content/preview","previewImg":"preview3_2.jpg","previewAlt":"TODO"},{"title":"斐波那契蜜蜂","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/72/task/1386/content/preview","previewImg":"preview3_2.jpg","previewAlt":"TODO"}]},{"image":"preview3_3.jpg","title":"中学数学思维课：代数与无穷数","buyUrl":"http://www.ddianke.com/course/74","blocks":[{"title":"适龄学生","content":"初中6-9年级生"},{"title":"课程简介","content":"在《代数与无穷数计算》课程中，罗教授将重点研究如何使用代数作为工具，用创造性的方式探索，来对无穷数进行深度解构，并尝试用这些知识帮助同学们初识微积分，向大家展示使用代数来解决这些问题的高效性和巧妙性。\n\n在这门课里，罗教授将会带领同学们从用代数法求抛物线面积开始，讲解包括黄金比例，等比数列，绝对值与抛物线斜率等，虚数多种数学问题。尽管这些问题的解法看似截然不同，然而罗教授都能过通过巧妙的应用代数知识，帮助同学们拨开谜团，寻找共性，使同学学都能够利用代数来思考并解决问题。"},{"title":"课程设计","content":"•\t使用创造性的方法寻找代数中的模式，结合可视化元素和几何思想展示代数的应用，涵盖图证法、无穷数等主题\n•\t14道精心设计的代表性代数与无穷数计算题目\n•\t14课时（不含课程介绍），时长共 196分钟"},{"title":"课程大纲","content":"任务1： 课程介绍\n任务2： 1+4+9+16+25+36+49+64+81 用代数方法求平方和\n任务3： y=x^2 完美抛物线一 用数列方法求抛物线面积\n任务4： 1+8+27+64+125+216＋343+512 图证法求立方和\n任务5： 1x2x3+2x3x4+3x4x5+4x5x6 排列组合法计算三个连续整数乘法和\n任务6： 1/(√1+√2)+1/(√2+√3)+1/(√3+√4) 望远镜和\n任务7： √1+√1+√1+.... 代数与图证法求解黄金比例\n任务8： 1+1-1+1-1+1-1….. 特殊的无穷不收敛等比数列\n任务9： 1+1/x 连分数与黄金比例\n任务10： 如何画一个黄金比例的长方形\n任务11： 如何计算抛物线的斜率\n任务12： 寻找抛物线的焦点\n任务13： 抛物线截距与与乘法计算\n任务14： | x-2 | = | x-8 | 绝对值与距离\n任务15： 求 1/x + 1/y =1/6 的正整数解"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"课程介绍","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/74/task/1418/content/preview","previewImg":"preview3_3.jpg","previewAlt":"TODO"},{"title":"用代数方法求平方和","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/74/task/1419/content/preview","previewImg":"preview3_3.jpg","previewAlt":"TODO"}]},{"image":"preview3_4.jpg","title":"数学思维课：概率入门","buyUrl":"http://www.ddianke.com/course/262","blocks":[{"title":"适龄学生","content":"初高中7-12年级生，具备较强的逻辑思维能力"},{"title":"课程简介","content":"概率与我们的生活息息相关，无论你是体育爱好者，或是深度游戏玩家，都一定曾或多或少的遇到过关于概率的问题，有些问题看似简单，凭着直觉就能找到答案，有些问题的答案却让我们大跌眼镜。\n\n概率论是集中研究概率及随机现象的数学分支，是统计学的基础，同时在金融，人工智能，量子力学中都起着举足轻重的作用。\n\n中学生学习概率，有助于对数学产生更直观的认识，同时培养反直觉的思维模式，另一方面，相比数学的其他分支，概率的知识很容易和现实生活相关联，也就更容易用来指导生活，培养理性看待问题的习惯。\n\n在《概率入门》课程中，罗教授将会带着同学们从生活中的问题入手，通过图例，假设，联想的方法，贯穿期望值，贝叶斯定理，条件概率等知识点，引发学生对数学规律的思考，并带领同学们进入妙趣横生的概率学大门。"},{"title":"课程设计","content":"•\t精心挑选和设计高含金量的题目，融入多种数学思维方法\n•\t首次在课程视频中插入练习题，通过交互式练习与小颗粒度学习\n•\t12个课时，共计190分钟"},{"title":"课程大纲","content":"任务1： 棒球得分统计——计数\n任务2： 对骰子的理解——期望\n任务3： 在考试中猜答案——期望与猜测\n任务4： 独立随机事件——独立性\n任务5： 你生病了——条件概率\n任务6： 两枚硬币——条件概率\n任务7： 还是两枚硬币——条件概率\n任务8： 零和博弈——博弈论\n任务9： 一直反常——期望与不等式\n任务10： 更好的猜测——期望\n任务11： 正面还是反面——期望\n任务12： 正面还是反面2——线性期望"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"棒球得分统计——计数","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/262/task/7302/content/preview","previewImg":"preview3_4.jpg","previewAlt":"TODO"}]}]},{"title":"AMC专题","ageGroup":"4-10年级学生","courses":[{"image":"preview4_1.jpg","title":"AMC8 入门精讲","buyUrl":"http://www.ddianke.com/course/267","blocks":[{"title":"适龄学生","content":"中小学4-8年级生"},{"title":"课程简介","content":"AMC (American Mathematics Competitions) ,美国数学竞赛，成立于1950年，每年仅在北美地区应试人数超过600,000人，是世界上目前信度和效度最高的数学科试题，汇聚了全球顶尖的数学人才，承担为美国选拔世界数学奥林匹克IMO选手的重任。\n\nAMC 8是针对八年级及以下学生的数学测验，内容包含25道选择题、考试时间40分钟。其测验目的是为了增进学生对数学习题解答的能力，激发学生增加对数学理解能力的潜能。测验题目不仅是从易到难，而且还涵盖了较广泛的数学实际应用。成绩表现不错的学生将被邀请参加AMC10测验。\n\n《AMC 8入门精讲》是罗教授参照美国数学竞赛AMC 8，特别针对国内小学生重新打造。全新设计的25道问题及讲解，难度与AMC 8竞赛题目相同。在课程中，罗教授将会带领学生们一起玩乐高、俄罗斯方块，也会和学生们一起看电影、搭配服装、一起外出旅行。通过解决隐藏在生活点滴中的数学问题，和我们一起学习日期、质数、排列组合、基础几何等多种多样的数学知识。罗教授通过这些问题，强调基础知识和概念，但又加以扩展，而且从多种角度来创造性解决问题，对培养系统思维和灵活运用多种方法有很大帮助。"},{"title":"课程设计","content":"•\t25道精心挑选的代表性AMC 8题目\n•\t25课时，对应AMC25道题，时长共 260分钟"},{"title":"课程大纲","content":"任务1：互相补给的海盗\n任务2：星战乐高\n任务3：星期五是13号\n任务4：俄罗斯方块\n任务5：递归\n任务6：游泳池\n任务7：旗帜的面积\n任务8：上下波动\n任务9：图形难题\n任务10：三角形的问题\n任务11：电影票\n任务12：极好的骰子\n任务13：5们\n任务14：家庭旅游\n任务15：柠檬水\n任务16：服装搭配\n任务17：完美的乘积\n任务18：正方形\n任务19：黄金三角形\n任务20：不同的三角形\n任务21：圆周率\n任务22：避开\n任务23：分糖\n任务24：数谜\n任务25：领奖台"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"互相补给的海盗","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/267/task/7487/content/preview","previewImg":"preview4_1.jpg","previewAlt":"TODO"},{"title":"俄罗斯方块","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/267/task/7490/content/preview","previewImg":"preview4_1.jpg","previewAlt":"TODO"}]},{"image":"preview4_2.jpg","title":"AMC10 精讲课","buyUrl":"http://www.ddianke.com/course/216","blocks":[{"title":"适龄学生","content":"初中7-10年级生"},{"title":"课程简介","content":"AMC是American Mathematics Competition是美国数学竞赛的缩写，由美国数学协会（Mathematics Association of America）于1950年成立，是世界上目前信度最高的数学科测试。试题简难兼具，使任何程度的学生都能感受到挑战，还可以筛选出特有天赋者。这项竞赛就是为所有喜爱数学的学生所开发的。\n\nAMC10是美国高中数学竞赛中的一项，是面向10年级及以下学生的数学竞赛，该竞赛开始于2000年，共25道问题。AMC10竞赛的目的是通过在测试中解决具有刺激并富于挑战的问题，提高学生在数学方面的兴趣及问题解决能力，竞赛内容为除去微积分以外的高中数学。\n\n在这一系列的《罗博深AMC10精讲课》中，罗教授参照美国数学竞赛AMC10，全新设计的25道问题,将会带领学生们通过解析一道道题目，将初等代数、数论、基础几何、排列组合、概率等多种多样的数学知识进行串联。罗教授通过这些问题，强调基础知识和概念并加以扩展，从多种角度来创造性解决问题，对培养系统思维和灵活运用多种方法有很大帮助。"},{"title":"课程设计","content":"•\t25道精心挑选的代表性AMC 10题目\n•\t25课时，对应AMC25道题，时长共 260分钟"},{"title":"课程大纲","content":"任务1：分享披萨\n任务2：繁分数\n任务3：缺零钱\n任务4：梯形\n任务5：百分比\n任务6：体积\n任务7：操作不当\n任务8：价格波动\n任务9：整数数列\n任务10：闪电\n任务11：镜面对称\n任务12：排队的鸭子\n任务13：转动的轮子\n任务14：零食要吃完了\n任务15：海风\n任务16：冰淇淋\n任务17：半个W\n任务18：彩色玻璃窗\n任务19：有1了\n任务20：黄金平分线\n任务21：更多彩色玻璃窗\n任务22：小白鼠\n任务23：地砖\n任务24：隧道\n任务25：循环的规律"}],"reviews":[{"name":"","school":"","content":""}],"videos":[{"title":"分享披萨","shortDescription":"","longDescription":"","url":"http://www.ddianke.com/course/216/task/5213/content/preview","previewImg":"preview4_2.jpg","previewAlt":"TODO"}]}]}]

/***/ }),

/***/ "neLX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"course":"course__3ZLsh","reviewCard":"reviewCard__2rIxE","readMore":"readMore__G8Gj4","downCaret":"downCaret__20O7W","videoCard":"videoCard__2-bBd","videoData":"videoData__2Cn1Z","videoPreview":"videoPreview__2z6dE","stickyMenu":"stickyMenu__1MF7E","stickyPageLinks":"stickyPageLinks__2n7p8","active":"active__1aO5c","scrollerContainer":"scrollerContainer__3z6Qw","buyCourse":"buyCourse__29zoI","popUpVideo":"popUpVideo__2eIKp","content":"content__EbpK2","normal":"normal__24aLW","classContent":"classContent__2PaeO","classContentMobile":"classContentMobile__1CiTt","headerDisplay":"headerDisplay__1oE5T","stickyMenuToggled":"stickyMenuToggled__zZLKG","items":"items__3G12Y","tooltip":"tooltip__kGAlr","modalOverlay":"modalOverlay__3yIt9","modalOverlayToggled":"modalOverlayToggled__1qfXv","modal":"modal__1ohwl","modalToggled":"modalToggled__2rHW2","reviewModal":"reviewModal__3DUj_","reviewTopBar":"reviewTopBar__3RzT-","reviewContentModal":"reviewContentModal__1MafZ","videoModal":"videoModal__3wv67","videoTopBar":"videoTopBar__2YPy9","videoBottomBar":"videoBottomBar__1pCLf","videoDescription":"videoDescription__1nCDs","closeButton":"closeButton__UhZZJ","singleItem":"singleItem__-PS6l","icon":"icon__mzi1d","headerText":"headerText__2weFm","courseTitle":"courseTitle__7PGsw","tooltiptext":"tooltiptext__1NNkT","courseContent":"courseContent__24JYL","courseText":"courseText__2Ru8w","courseLine":"courseLine__1pGPG"};

/***/ }),

/***/ "ohqm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"box":"box__1bpQv","row":"row__d8aMW","column":"column__2GSFS","smRow":"smRow__2LL1B","smColumn":"smColumn__28WDX","transparent":"transparent__lUMYU","white":"white__YELTs","gray":"gray__UwoHf","blue":"blue__23Gt5","dark":"dark__8CmDj","square":"square__1-57S","round":"round__3Dqgm","align-initial":"align-initial__2Vzzv","align-start":"align-start__kt0HD","align-end":"align-end__2rX26","align-center":"align-center__3PGdz","align-stretch":"align-stretch__-NCZg","justify-initial":"justify-initial__22rry","justify-start":"justify-start__PlxTo","justify-end":"justify-end__3IItd","justify-center":"justify-center__3QfCZ","justify-around":"justify-around__38Iyy","justify-between":"justify-between__1gHQJ","nowrap":"nowrap__AK_0b","wrap":"wrap__1Uotj","reverse":"reverse__3BqLn"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q6qL":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__("KM04")) : typeof define === 'function' && define.amd ? define(['preact'], factory) : global.preactPortal = factory(global.preact);
})(this, function (preact) {
  'use strict';

  var asyncGenerator = function () {
    function AwaitValue(value) {
      this.value = value;
    }

    function AsyncGenerator(gen) {
      var front, back;

      function send(key, arg) {
        return new Promise(function (resolve, reject) {
          var request = {
            key: key,
            arg: arg,
            resolve: resolve,
            reject: reject,
            next: null
          };

          if (back) {
            back = back.next = request;
          } else {
            front = back = request;
            resume(key, arg);
          }
        });
      }

      function resume(key, arg) {
        try {
          var result = gen[key](arg);
          var value = result.value;

          if (value instanceof AwaitValue) {
            Promise.resolve(value.value).then(function (arg) {
              resume("next", arg);
            }, function (arg) {
              resume("throw", arg);
            });
          } else {
            settle(result.done ? "return" : "normal", result.value);
          }
        } catch (err) {
          settle("throw", err);
        }
      }

      function settle(type, value) {
        switch (type) {
          case "return":
            front.resolve({
              value: value,
              done: true
            });
            break;

          case "throw":
            front.reject(value);
            break;

          default:
            front.resolve({
              value: value,
              done: false
            });
            break;
        }

        front = front.next;

        if (front) {
          resume(front.key, front.arg);
        } else {
          back = null;
        }
      }

      this._invoke = send;

      if (typeof gen.return !== "function") {
        this.return = undefined;
      }
    }

    if (typeof Symbol === "function" && Symbol.asyncIterator) {
      AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      };
    }

    AsyncGenerator.prototype.next = function (arg) {
      return this._invoke("next", arg);
    };

    AsyncGenerator.prototype.throw = function (arg) {
      return this._invoke("throw", arg);
    };

    AsyncGenerator.prototype.return = function (arg) {
      return this._invoke("return", arg);
    };

    return {
      wrap: function wrap(fn) {
        return function () {
          return new AsyncGenerator(fn.apply(this, arguments));
        };
      },
      await: function _await(value) {
        return new AwaitValue(value);
      }
    };
  }();

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  var Portal = function (_Component) {
    inherits(Portal, _Component);

    function Portal() {
      classCallCheck(this, Portal);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
      for (var i in props) {
        if (props[i] !== this.props[i]) {
          return setTimeout(this.renderLayer);
        }
      }
    };

    Portal.prototype.componentDidMount = function componentDidMount() {
      this.isMounted = true;
      this.renderLayer = this.renderLayer.bind(this);
      this.renderLayer();
    };

    Portal.prototype.componentWillUnmount = function componentWillUnmount() {
      this.renderLayer(false);
      this.isMounted = false;
      if (this.remote) this.remote.parentNode.removeChild(this.remote);
    };

    Portal.prototype.findNode = function findNode(node) {
      return typeof node === 'string' ? document.querySelector(node) : node;
    };

    Portal.prototype.renderLayer = function renderLayer() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.isMounted) return;

      if (this.props.into !== this.intoPointer) {
        this.intoPointer = this.props.into;
        if (this.into && this.remote) {
          this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
        }
        this.into = this.findNode(this.props.into);
      }

      this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
    };

    Portal.prototype.render = function render() {
      return null;
    };

    return Portal;
  }(preact.Component);

  var PortalProxy = function (_Component2) {
    inherits(PortalProxy, _Component2);

    function PortalProxy() {
      classCallCheck(this, PortalProxy);
      return possibleConstructorReturn(this, _Component2.apply(this, arguments));
    }

    PortalProxy.prototype.getChildContext = function getChildContext() {
      return this.props.context;
    };

    PortalProxy.prototype.render = function render(_ref) {
      var children = _ref.children;

      return children && children[0] || null;
    };

    return PortalProxy;
  }(preact.Component);

  return Portal;
});
//# sourceMappingURL=preact-portal.js.map

/***/ }),

/***/ "qzhV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac14d65fd2e49826580f4157ff974744.svg";

/***/ }),

/***/ "rAoZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("+eY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);




var Button = function Button(_ref) {
	var children = _ref.children,
	    href = _ref.href,
	    onClick = _ref.onClick;

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
		{ 'class': __WEBPACK_IMPORTED_MODULE_2__style___default.a.button, onClick: onClick, href: href },
		children
	);
};
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "rq4c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "szLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"lightgray":"lightgray__ZzEqO","gray":"gray__1h4E9","dark":"dark__2xpho","white":"white__2ZLuH","light":"light__11NJt","normal":"normal__1cWsX","medium":"medium__2uxr9","bold":"bold__2yB8F","left":"left__21Wib","center":"center__1V_E-","right":"right__18gZG"};

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header__3QGkI","active":"active__3gItZ"};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.f0df3.js